'use strict'
import '~/assets/scss/analytic.scss'
import '~/js/modules/upward'
// import SlimSelect from 'slim-select'
require('slim-select')
import 'slim-select/scss'
import noUiSlider from 'nouislider'
import { debounce } from '~/js/helpers/utils.js'
import List from 'list.js'
import JSZip from 'jszip'
window.JSZip = JSZip
import '~/js/modules/buttons-html5'
import * as bonds from '~/js/modules/bonds'
import { market_map_foo } from '~/js/modules/bonds-market-map'
import { bondsPortfolio } from '~/js/modules/bonds-portfolio'
import IMask from 'imask'
import '~/js/modules/promo-banner';

/* Глобальная переменная. Идентифицирует запуск общего сброса фильтров */
let globalReset = false
/* Выбор фильтра, потому что десктопные и мобильные фильтры - это разная разметка */
let value__i = 0
if (bonds.mobileAndTabletCheck() == true) {
  value__i = 1
} else {
  value__i = 0
}

bondsPortfolio()
bonds.js__toggle()
/* Маска на все инпуты для чисел */
const inputElements = document.querySelectorAll('.range__field:not(.range__field-non-mask)')
const maskOptions = {
  mask: Number,
  signed: true,
  radix: '.',
  mapToRadix: [','],
}
inputElements.forEach((ie) => {
  IMask(ie, maskOptions);
})

/* Поиск в выпадающем списке */
let options = {
  valueNames: [ 'bonds__filters-btn__name' ]
};
/* по отраслям */
let sector_list__desktop = new List('js__sector_text--list__desktop', options);
let sector_list__mobile = new List('js__sector_text--list__mobile', options);
/* по странам */
let borrower_country__desktop = new List('js__borrower_country--list__desktop', options);
let borrower_country__mobile = new List('js__borrower_country--list__mobile', options);

const marketMapTabButton = document.querySelectorAll('.js-bonds__filters-tab_market-map')

const newDateGenCheckbox = document.querySelectorAll('.js-new_date_gen')

const input = document.getElementsByClassName('js-upload-xls-input')[0]
const iBondRange = document.querySelectorAll('.js-ibond_range')

const complexity_range_from = (document.querySelectorAll('.complexity_from').length > 0) ? document.querySelectorAll('.complexity_from')[value__i] : null;
const complexity_range_to = (document.querySelectorAll('.complexity_to').length > 0) ? document.querySelectorAll('.complexity_to')[value__i] : null;
const complexity_range__slider = document.querySelectorAll('.complexity_range')
const complexity_range_default_from = (complexity_range_from != null) ? complexity_range_from.getAttribute('data-default-value') : null;
const complexity_range_default_to = (complexity_range_to != null) ? complexity_range_to.getAttribute('data-default-value') : null;

const quality_range_from = document.querySelectorAll('.quality_from')
const quality_range_to = document.querySelectorAll('.quality_to')
const quality_range__slider = document.querySelectorAll('.quality_range')
const quality_default_range_from = (quality_range_from.length > 0) ? quality_range_from[0].getAttribute('data-default-value') : null;
const quality_default_range_to = (quality_range_to.length > 0) ? quality_range_to[0].getAttribute('data-default-value') : null;

const liquidity_checkbox = document.querySelectorAll('.js-liquidity-checkbox')

const bondFilters = document.querySelectorAll('.js__filter')
const bondFilterChips = document.querySelector('.js__filter-chips')
const bondFilterLocalSearch = document.querySelectorAll('.js__localsearch')
const bondFilterClears = document.querySelectorAll('[data-filters-clear]')
const bondFilterAppliedClears = document.querySelectorAll('[data-applied-clear]')
const bondFilterMobileBtns = document.querySelectorAll('[data-filter-open]')
const bondFilterMobileCloseBtns = document.querySelectorAll('[data-filter-open-modal]')
const bondFilterMobileModals = document.querySelectorAll('[data-filter-modal]')
const bondFilterMobileCloses = document.querySelectorAll('[data-filter-close]')
/* Интеллектуальный отбор */
const iBondCheckbox = document.querySelectorAll('.js__checkbox_ibond')
const ibondRangeContainer = document.querySelectorAll('.js-ibond-range-container')
/* Подбор замены */
const replacementInput = document.querySelectorAll('.js-replacement__input')
const replacementSubmit = document.querySelectorAll('.js-replacement-submit')
const replacementClearButton = document.querySelector('.js-field-text-bottom')
const replacementModesContainer = document.querySelectorAll('.js-mode-replacement')
/* Загрузка портфеля */
const loadXlsButton = document.getElementsByClassName('js-load-xls-table')[0]
const xlsFileInput = document.getElementsByClassName('js-upload-xls-input')[0]
/* ссылка на отдельную страницу облигации */
const link_to_bond = (row) => {
  return ' <a href="https://analytics.dohod.ru/bond/' + row.xml_isin + '" target="_blank" title="открыть облигацию в отдельной вкладке"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 14a1 1 0 0 0-1 1v3.077c0 .459-.022.57-.082.684a.363.363 0 0 1-.157.157c-.113.06-.225.082-.684.082H5.923c-.459 0-.571-.022-.684-.082a.363.363 0 0 1-.157-.157c-.06-.113-.082-.225-.082-.684L4.999 5.5a.5.5 0 0 1 .5-.5l3.5.005a1 1 0 1 0 .002-2L5.501 3a2.5 2.5 0 0 0-2.502 2.5v12.577c0 .76.083 1.185.32 1.627.223.419.558.753.977.977.442.237.866.319 1.627.319h12.154c.76 0 1.185-.082 1.627-.319.419-.224.753-.558.977-.977.237-.442.319-.866.319-1.627V15a1 1 0 0 0-1-1zm-2-9.055v-.291l-.39.09A10 10 0 0 1 15.36 5H14a1 1 0 1 1 0-2l5.5.003a1.5 1.5 0 0 1 1.5 1.5V10a1 1 0 1 1-2 0V8.639c0-.757.086-1.511.256-2.249l.09-.39h-.295a10 10 0 0 1-1.411 1.775l-5.933 5.932a1 1 0 0 1-1.414-1.414l5.944-5.944A10 10 0 0 1 18 4.945z" fill="currentColor"/></svg></a>'
}

const mainHeader = document.querySelector('.new-header .header')
if (mainHeader) {
  let headerHeight = mainHeader.offsetHeight
  const thead = document.querySelector('.js-bonds__table-thead')
  if (thead) {
    thead.style.top = headerHeight + 'px'
  }
}
/* ОБъект для параметров фильтрации, передаваемых на бэк */
let postData = {}
/* Блоки с фильтрами ползунок-инпут */
const ranges = document.querySelectorAll('.js__range')

let years_to_maturity_checkbox = (e) => {
  if ($('.js-years_to_maturity_checkbox').hasClass('is-active')) {
    $('.js-years_to_maturity--block').slideUp()
  } else {
    $('.js-years_to_maturity--block').slideDown()
  }
}

let simple_liquid_checkbox = function () {
  const checkboxsl = document.querySelectorAll('.js-checkbox__simple_liquid')[value__i]
  if (checkboxsl.classList.contains('is-active')) {
    if(complexity_range_from != null && !complexity_range_from.hasAttribute('disabled')) {
      complexity_range_from.value = 0
      complexity_range_to.value = 2
      complexity_range_from.setAttribute('disabled', true)
      complexity_range_to.setAttribute('disabled', true)
      complexity_range__slider.forEach((rs) => {
        rs.noUiSlider.set([0, 2])
        rs.setAttribute('disabled', true)
      })
      filterApplyHandler('factors')
      document.querySelectorAll('[data-filter="Сложность"]').forEach((el) => {
        el.dataset.previousFilter = el.dataset.appliedValue
      })
    }
    else if(complexity_range_from != null && complexity_range_from.hasAttribute('disabled')) {
      complexity_range_from.value = complexity_range_default_from
      complexity_range_to.value = complexity_range_default_to
      complexity_range_from.removeAttribute('disabled')
      complexity_range_to.removeAttribute('disabled')
      complexity_range__slider.forEach((rs) => {
        rs.noUiSlider.set([complexity_range_default_from, complexity_range_default_to])
        rs.removeAttribute('disabled')
      })
    }
    liquidity_only__checkbox(true)
    filterApplyHandler('liquidity')
    document.querySelectorAll('[data-filter="Ликвидность"]').forEach((el) => {
      el.dataset.previousFilter = el.dataset.appliedValue
    })
  } else {
    if(complexity_range_from != null && complexity_range_from.hasAttribute('disabled')) {
      liquidity_only__checkbox(false)
      filterClearHandler('Ликвидность')
      filterApplyHandler('liquidity')
      bondFilterMobileBtns.forEach((btn) => {
        if(btn.dataset.filterOpen == 'basic'){
          btn.classList.remove('is-applied')
          btn.querySelector('.bonds-filter__modal-btn_list').innerHTML = ''
        }
      })
      document.querySelectorAll('[data-filter="Ликвидность"]').forEach((el) => {
        el.dataset.previousFilter = 'default'
      })
      complexity_range_from.value = complexity_range_default_from
      complexity_range_to.value = complexity_range_default_to
      complexity_range_from.removeAttribute('disabled')
      complexity_range_to.removeAttribute('disabled')
      complexity_range__slider.forEach((rs) => {
        rs.noUiSlider.set([complexity_range_default_from, complexity_range_default_to])
        rs.removeAttribute('disabled')
      })
      filterClearHandler('Сложность')
      filterApplyHandler('factors')
      document.querySelectorAll('[data-filter="Сложность"]').forEach((el) => {
        el.dataset.previousFilter = 'default'
      })
    }
    else if(complexity_range_from == null) {
      liquidity_only__checkbox(false)
      filterClearHandler('Ликвидность')
      filterApplyHandler('liquidity')
      bondFilterMobileBtns.forEach((btn) => {
        if(btn.dataset.filterOpen == 'basic'){
          btn.classList.remove('is-applied')
          btn.querySelector('.bonds-filter__modal-btn_list').innerHTML = ''
        }
      })
      document.querySelectorAll('[data-filter="Ликвидность"]').forEach((el) => {
        el.dataset.previousFilter = 'default'
      })
    }
  }
  debounce(oTable.ajax.reload(), 500)
}

const not_reinvesting_checkbox = function () {
  if ($('.js-dont_reinvesting').hasClass('is-active')) {
    return true;
  } else {
    return false;
  }
}

let trust_proper_checkbox = function () {
  const checkboxtp = document.querySelectorAll('.js-checkbox__trust_proper')[value__i]
  const crRatAAA= document.querySelectorAll('.js-credit_rating_text [data-filter="AA,AAA"]')
  const crRatA = document.querySelectorAll('.js-credit_rating_text [data-filter="A"]')
  const crRatBBB = document.querySelectorAll('.js-credit_rating_text [data-filter="BBB"]')
  const crRatings = document.querySelectorAll('.js-credit_rating_text [data-filter]')

  if (checkboxtp.classList.contains('is-active')) {
    if(quality_range_from.length > 0 && !quality_range_from[0].hasAttribute('disabled')) {
      quality_range_from.forEach((el) => {
        el.value = 5
        el.setAttribute('disabled', true)
      })
      quality_range_to.forEach((el) => {
        el.value = 10
        el.setAttribute('disabled', true)
      })
      quality_range__slider.forEach((el) => {
        el.noUiSlider.set([5, 10])
        el.setAttribute('disabled', true)
      })
      document.querySelectorAll('[data-filter="Качество"]').forEach((el) => {
        el.dataset.previousFilter = el.dataset.appliedValue
      })
    }
    else if(quality_range_from.length > 0 && quality_range_from[0].hasAttribute('disabled')) {
      if(quality_range_from.length > 0) {
        quality_range_from.forEach((el) => {
          el.value = quality_default_range_from
          el.removeAttribute('disabled')
        })
        quality_range_to.forEach((el) => {
          el.value = quality_default_range_to
          el.removeAttribute('disabled')
        })
        quality_range__slider.forEach((el) => {
          el.noUiSlider.set([quality_default_range_from, quality_default_range_to])
          el.removeAttribute('disabled')
        })
        document.querySelectorAll('[data-filter="Качество"]').forEach((el) => {
          el.dataset.previousFilter = 'default'
        })
      }
    }

    if (!crRatAAA[value__i].classList.contains('is-active'))
    {
      filtersChangeHandler(crRatAAA[value__i], 'AA,AAA')
      crRatAAA.forEach((el) => {
        el.setAttribute('data-applied-value', 'AA,AAA')
        el.setAttribute('data-previous-filter', 'AA,AAA')
      })
    }
    if (!crRatA[value__i].classList.contains('is-active'))
    {
      filtersChangeHandler(crRatA[value__i], 'A');
      crRatA.forEach((el) => {
        el.setAttribute('data-applied-value', 'A')
        el.setAttribute('data-previous-filter', 'AA,AAA')
      })
    }
    if (!crRatBBB[value__i].classList.contains('is-active'))
    {
      filtersChangeHandler(crRatBBB[value__i], 'BBB')
      crRatBBB.forEach((el) => {
        el.setAttribute('data-applied-value', 'BBB')
        el.setAttribute('data-previous-filter', 'AA,AAA')
      })
    }
    filterClearHandler('BB,BB-')
    filterClearHandler('B+,B-,B')
    filterClearHandler('CCC,CC,C')
    filterClearHandler('D')
    filterClearHandler('Array')
    filterApplyHandler('qualities')
    filterApplyHandler('credit')
  } else {
    if(quality_range_from.length > 0) {
      quality_range_from.forEach((el) => {
        el.value = quality_default_range_from
        el.removeAttribute('disabled')
      })
      quality_range_to.forEach((el) => {
        el.value = quality_default_range_to
        el.removeAttribute('disabled')
      })
      quality_range__slider.forEach((el) => {
        el.noUiSlider.set([quality_default_range_from, quality_default_range_to])
        el.removeAttribute('disabled')
      })
      document.querySelectorAll('[data-filter="Качество"]').forEach((el) => {
        el.dataset.previousFilter = 'default'
      })
    }

    crRatings.forEach((el) => {
      filterClearHandler(el.dataset.filter)
      el.setAttribute('data-previous-filter', 'default')
    })

    filterClearHandler('Качество')
    //filterApplyHandler('qualities')
    filterApplyHandler('credit')
  }
  debounce(oTable.ajax.reload(), 500)
}

const liquidity_only__checkbox = function (status = true) {

  const liquidity_range_from = (document.querySelectorAll('.liquidity_from').length > 0) ? document.querySelectorAll('.liquidity_from')[value__i] : null;
  const liquidity_range_to = (document.querySelectorAll('.liquidity_to').length > 0) ? document.querySelectorAll('.liquidity_to')[value__i] : null;
  const range__slider = document.querySelectorAll('.liquidity_range')
  const range_from = (liquidity_range_from != null) ? liquidity_range_from.getAttribute('data-default-value') : null;
  const range_to = (liquidity_range_to != null) ? liquidity_range_to.getAttribute('data-default-value') : null;

  liquidity_checkbox.forEach((el) => {
    if ( status == true ) {
      el.classList.add('is-active')
      el.setAttribute('data-applied-value', el.dataset.filter)
      el.setAttribute('data-previous-filter', el.dataset.filter)
    }

    if ( status == false ) {
      el.classList.remove('is-active')
      el.removeAttribute('data-applied-value');
      el.setAttribute('data-previous-filter', 'default')
    }

    if ( el.classList.contains('is-active') ) {
      if(liquidity_range_from != null) {
        liquidity_range_from.value = 50
        liquidity_range_from.setAttribute('disabled', true)
        liquidity_range_to.setAttribute('disabled', true)
        range__slider.forEach((rs) => {
          rs.noUiSlider.set([50, range_to])
          rs.setAttribute('disabled', true)
        })
      }
      else if(liquidity_range_from != null) {
        liquidity_range_from.removeAttribute('disabled')
        liquidity_range_to.removeAttribute('disabled')
        range__slider.forEach((rs) => {
          rs.removeAttribute('disabled')
        })
      }
    } else {
      if(liquidity_range_from != null) {
        liquidity_range_from.value = liquidity_range_from.getAttribute('data-default-value')
        liquidity_range_from.removeAttribute('disabled')
        liquidity_range_to.removeAttribute('disabled')
        range__slider.forEach((rs) => {
          rs.noUiSlider.set([range_from, range_to])
          rs.removeAttribute('disabled')
        })
        filterClearHandler('Ликвидность')
      }
      filterClearHandler('Простые и ликвидные')
      if(complexity_range_from != null) {
        complexity_range_from.removeAttribute('disabled')
        complexity_range_to.removeAttribute('disabled')
        complexity_range__slider.forEach((rs) => {
          rs.removeAttribute('disabled')
        })
      }
      filterApplyClearHandler('basic')
    }
  })
}
/* Очистка выбранного фильтра */
const filterClearHandler = (filter, type, selectClassList) => {
  const dataFilterChip = document.querySelectorAll('[data-filter-chip]')
  dataFilterChip.forEach((el) => {
    if (el.dataset.filterChipType == 'js__select') {
      let elGroup = el.dataset.filterChipTypeGroup
      let selectedGroup = false
      if (selectClassList) {
        selectedGroup = selectClassList.contains(elGroup)
      }
      if(el.dataset.filterChip != filter && type == 'select' && selectedGroup){
        el.remove()
      }
    }
    if (el.dataset.filterChip == filter){
      el.remove()
    }
  })
  const dataFilter = document.querySelectorAll("[data-filter]")
  dataFilter.forEach((el) => {
    if(el.dataset.filter == filter){
      el.classList.remove('is-active');
      el.removeAttribute('data-applied-value');
      filterApplyHandler(el.dataset.filterOpenModal)

      const curBtn = document.querySelectorAll('.bonds__filters-tab_currency')
      const strBtn = document.querySelectorAll('.bonds__filters-tab_strategy')

      const selectsReset = (node) => {
        Array.from(el.options).forEach((option) => {
          option.classList.remove('is-active')
        })
        el.options[0].classList.add('is-active');
        el.options[0].selected = true
        node.forEach((el) => {
          el.removeAttribute('disabled')
        })
      }
      if (el.classList.contains('js__select') && type == 'currency__id') {
        selectsReset(curBtn)
      }

      if (el.classList.contains('js__select') && type == 'strategy') {
        selectsReset(strBtn)
      }

    }
  })

  if (globalReset == false) {
    filtersClearTrigger()
  }
}
const inputRangeClearHandler = (filter) => {
  // console.log(filter);
  const rangeFieldsInput = filter.querySelectorAll('.range__field')
  const rangeSliderSets = filter.querySelector('.range__slider')
  if (rangeSliderSets !== null ) {
    if ( rangeFieldsInput.length > 1 ) {
      rangeSliderSets.noUiSlider.set([
        rangeFieldsInput[0].dataset.defaultValue,
        rangeFieldsInput[1].dataset.defaultValue
      ])
    }
  }

  if ( rangeFieldsInput.length !== 0 ) {
    rangeFieldsInput[0].value = rangeFieldsInput[0].dataset.defaultValue
    if ( rangeFieldsInput.length > 1 ) {
      rangeFieldsInput[1].value = rangeFieldsInput[1].dataset.defaultValue
    }
  }
}
const filterSetHandler = (filter, filterName) => {
  const chip = document.createElement('div')
  const chipText = document.createElement('span')
  const chipButton = document.createElement('button')

  chip.className = 'bonds__filters-chip'
  chipButton.className = 'bonds__filters-chip_remove'
  chipText.innerText = filterName
  chip.setAttribute('data-filter-chip', filter.dataset.filter)

  if (filter.classList.contains('estimationRating')) {
      switch (filterName) {
        case '-1':
          chipText.innerText = 'Оценка облигации Аномалия';
          break;
        case '-99':
          chipText.innerText = 'Оценка облигации n/a';
          break;
        case '0':
          chipText.innerText = 'Оценка облигации 0/5';
          break;
        case '1':
          chipText.innerText = 'Оценка облигации 1/5';
          break;
        case '2':
          chipText.innerText = 'Оценка облигации 2/5';
          break;
        case '3':
          chipText.innerText = 'Оценка облигации 3/5';
          break;
        case '4':
          chipText.innerText = 'Оценка облигации 4/5';
          break;
        case '5':
          chipText.innerText = 'Оценка облигации 5/5';
          break;
      }
  }
  if (filter.classList.contains('js__select')) {
    filterClearHandler(filterName)
    chip.setAttribute('data-filter-chip-type', 'js__select')
  }
  if (filter.classList.contains('currency__id')) {
    chip.setAttribute('data-filter-chip-type-group', 'currency__id')
  }
  if (filter.classList.contains('strategy')) {
    chip.setAttribute('data-filter-chip-type-group', 'strategy')
  }
  chip.appendChild(chipText)
  chip.appendChild(chipButton)
  filterClearHandler(filter.dataset.filterRemove)

  chipButton.addEventListener('click', () => {
    inputRangeClearHandler(filter)
    filterClearHandler(filter.dataset.filter)
    filterApplyHandler(filter.dataset.filterOpenModal)

    if (filter.dataset.filter == 'Новые выпуски') {
      newDateGenCheckbox.forEach((ndvch) => {
        ndvch.classList.remove('is-active')
      })
      filterApplyHandler('basic')
      filterApplyHandler('vpo')
      filterClearHandler('Новые выпуски')
    }
    if (filter.dataset.filter == 'Доступно для ИИС') {
      filterApplyHandler('basic')
      filterClearHandler('Доступно для ИИС')
    }
    if (filter.dataset.filter == 'Только ликвидные') {
      liquidity_only__checkbox(false)
    }
    if (filter.dataset.filter == 'Ликвидность') {
      liquidity_only__checkbox(false)
      filterClearHandler('Только ликвидные')
    }
    if(filter.dataset.filter == 'Я не буду реинвестировать купоны') {
      oTable.ajax.reload()
    }
    if (filter.dataset.filter == 'Простые и ликвидные') {
      simple_liquid_checkbox()
      filterClearHandler('Сложность')
      filterClearHandler('Ликвидность')
      filterApplyHandler('liquidity')
      filterApplyHandler('factors')
    }
    if (filter.dataset.filter == 'Надежные и качественные') {
      trust_proper_checkbox()
      filterClearHandler('Качество')
    }
    if (filter.dataset.filter == 'Сложность' || filter.dataset.filter == 'Ликвидность')
    {
      filterApplyHandler('basic')
      filterClearHandler('Простые и ликвидные')
    }
    if (filter.dataset.filter == 'Сложность')
    {
      complexity_range_from.removeAttribute('disabled')
      complexity_range_to.removeAttribute('disabled')
      complexity_range__slider.forEach((rs) => {
        rs.noUiSlider.set([complexity_range_default_from, complexity_range_default_to])
        rs.removeAttribute('disabled')
      })
      filterClearHandler('Сложность')
    }
    if (filter.dataset.filter == 'Качество') {
      filterClearHandler('Надежные и качественные')
      quality_range_from.forEach((el) => {
        el.value = quality_default_range_from
        el.removeAttribute('disabled')
      })
      quality_range_to.forEach((el) => {
        el.value = quality_default_range_to
        el.removeAttribute('disabled')
      })
      quality_range__slider.forEach((el) => {
        el.noUiSlider.set([quality_default_range_from, quality_default_range_to])
        el.removeAttribute('disabled')
      })
      filterClearHandler('Качество')
      filterApplyHandler('basic')
    }
    if (filter.dataset.filter == 'Карта рынка') {
      if (marketMapTabButton) {
        marketMapTabButton.forEach((el) => {
          if (!el.classList.contains('is-active')) {
            document.querySelector('.js-market_map--section').classList.remove('is-active')
            document.querySelector('.dataTables_wrapper').style.display = 'block'
            document.querySelector('.bonds__table-sorting--mobile').style.display = 'block'
          }
        })
      }

    }
    if (filter.dataset.filter == 'AA,AAA' || filter.dataset.filter == 'A' || filter.dataset.filter == 'BBB')
    {
      filterClearHandler('Надежные и качественные')
      quality_range_from.forEach((el) => {
        el.removeAttribute('disabled')
      })
      quality_range_to.forEach((el) => {
        el.removeAttribute('disabled')
      })
      quality_range__slider.forEach((el) => {
        el.removeAttribute('disabled')
      })
      //filterClearHandler('Качество')
      filterApplyHandler('basic')
    }
    if (filter.classList.contains('js__select')) {
      if (filter.classList.contains('strategy')) {
        const strChk = document.querySelectorAll('.js__strategy_checkbox')
        strChk.forEach((sc) => {
          sc.classList.remove('is-active')
        })
      }
      filterClearHandler(filter.dataset.filter, chip.dataset.filterChipTypeGroup)
    }

    if (filter.dataset.filter == 'Подбор замены') {
      oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=info' ).load()
      replacementClearButton.style.display = 'none'
      replacementModesContainer.forEach((rmc) => {
        rmc.classList.add('disabled')
      })
      replacementInput.forEach((ri) => {
        ri.value = ''
      })
    }
    if (filter.dataset.filter == 'Загруженный портфель') {
      oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=info' ).load()
      clearInputFile(xlsFileInput)
    }
    if (filter.dataset.filter == 'Интеллектуальный отбор') {
      ibondRangeContainer.forEach( (i) => {
        i.style.display = 'none'
      })
      oTable.column(57).search('').draw()
    }
    document.querySelectorAll('[data-filter="' + filter.dataset.filter + '"]').forEach((el) => {
      el.dataset.previousFilter = 'default'
    })
  })

  if (typeof filterName !== 'undefined' && filter.dataset.filter) {
    if(filter.dataset.filter == 'Качество') {
      if(bondFilterChips.querySelectorAll('[data-filter-chip="Качество"]').length == 0) {
        bondFilterChips.appendChild(chip)
      }
    }
    else {
      bondFilterChips.appendChild(chip)
    }
  }
  filter.setAttribute('data-applied-value', filterName)
}

const customChipRemove = document.querySelector('.js-chip_remove')
if (customChipRemove) {
  customChipRemove.addEventListener('click', () => {
    filterClearHandler('Россия')
    filterApplyHandler('borrower-country')
  })
}
const clearInputFile = (fileInput) => {
  const span = document.querySelectorAll('.js-xls-file-title')[0]
  const foundBonds = document.querySelectorAll('.js-found-bonds')[0]
  const notFoundBonds = document.querySelectorAll('.js-not-found-bonds')[0]

  if (span) {
    span.innerHTML = 'Выбрать файл Excel'
  }
  if (foundBonds) {
    foundBonds.innerHTML = ''
  }
  if (notFoundBonds) {
    notFoundBonds.innerHTML = ''
  }
  if (loadXlsButton) {
    loadXlsButton.style.display = 'none'
  }
  if(fileInput.value){
    try{
      fileInput.value = ''
    }catch(err){ }
  }
}

const filterApplyHandler = (filter) => {
  let applied = false;
  const filterAppliedList = []
  bondFilterMobileModals.forEach((modal) => {
    if(filter == modal.dataset.filterModal){
      if(modal.querySelectorAll('[data-applied-value]').length > 0){
        modal.querySelectorAll('[data-applied-value]').forEach((el) => {
          filterAppliedList.push(el.dataset.appliedValue)
        })
        applied = true
      }
      else{
        applied = false
      }
    }
  })
  bondFilterMobileBtns.forEach((btn) => {
    if(btn.dataset.filterOpen == filter) {
      if(applied == true){
        btn.querySelector('.bonds-filter__modal-btn_list').innerHTML = ''
        btn.classList.add('is-applied')
        filterAppliedList.forEach((el) => {
          const element = document.createElement('li')
          element.innerText = el
          btn.querySelector(".bonds-filter__modal-btn_list").appendChild(element)
        })
      }
      else{
        btn.classList.remove('is-applied')
        btn.querySelector('.bonds-filter__modal-btn_list').innerHTML = ''
      }
    }
  })
}
/* синхронизация чекбоксов новых выпусков */
newDateGenCheckbox.forEach((ndgch) => {
  ndgch.addEventListener('click', () => {

    setTimeout(() => {
      if (ndgch.classList.contains('is-active')) {
        newDateGenCheckbox.forEach((ndvch) => {
          ndvch.classList.add('is-active')
          ndvch.dataset.appliedValue = 'Новые выпуски'
          ndvch.dataset.previousFilter = 'Новые выпуски'
        })
      } else {
        newDateGenCheckbox.forEach((ndvch) => {
          ndvch.classList.remove('is-active')
          ndvch.dataset.previousFilter = 'default'
        })
        filterClearHandler('Новые выпуски')
        bondFilterMobileBtns.forEach((btn) => {
          if(btn.dataset.filterOpen == 'basic'){
            btn.classList.remove('is-applied')
            btn.querySelector('.bonds-filter__modal-btn_list').innerHTML = ''
          }
        })
      }
    }, 500)
  })
})

const filterApplyClearHandler = (filter) => {
  bondFilterMobileBtns.forEach((el) => {
    if(el.dataset.filterOpen == filter){
      el.classList.remove('is-applied')
      el.querySelector('.bonds-filter__modal-btn_list').innerHTML = ''
    }
  })
  bondFilterMobileModals.forEach((modal) => {
    if(filter == modal.dataset.filterModal && filter !== 'basic'){
      modal.querySelectorAll('[data-filter]').forEach((el) => {
        el.dataset.previousFilter = 'default'
        filterClearHandler(el.dataset.filter)
        if (el.dataset.filter == 'Простые и ликвидные') {
          simple_liquid_checkbox()
          filterClearHandler('Простые и ликвидные')
          filterClearHandler('Сложность')
          filterClearHandler('Ликвидность')
          filterApplyHandler('liquidity')
          filterApplyHandler('factors')
        }
        if (el.dataset.filter == 'Только ликвидные') {
          liquidity_only__checkbox(false)
          simple_liquid_checkbox()
          filterClearHandler('Простые и ликвидные')
          filterClearHandler('Только ликвидные')
          filterClearHandler('Ликвидность')
        }
        if (el.dataset.filter == 'Ликвидность') {
          liquidity_only__checkbox(false)
          simple_liquid_checkbox()
          filterClearHandler('Простые и ликвидные')
          filterClearHandler('Только ликвидные')
        }
        if(el.dataset.filter == 'Сложность') {
          simple_liquid_checkbox()
          filterClearHandler('Простые и ликвидные')
          filterClearHandler('Сложность')
          filterApplyHandler('basic')
        }
        if (el.dataset.filter == 'Надежные и качественные') {
          trust_proper_checkbox()
          filterClearHandler('Надежные и качественные')
          filterClearHandler('Качество')
        }
        if (el.dataset.filter == 'Качество') {
          trust_proper_checkbox()
          filterClearHandler('Надежные и качественные')
          filterClearHandler('Качество')
        }
        if(el.dataset.filter == 'Я не буду реинвестировать купоны') {
          oTable.ajax.reload()
          filterClearHandler('Я не буду реинвестировать купоны')
        }
        if (el.dataset.filter == 'AA,AAA' || el.dataset.filter == 'A' || el.dataset.filter == 'BBB') {
          filterClearHandler('Надежные и качественные')

          if(quality_range_from.length > 0 && quality_range_from[0].hasAttribute('disabled')) {
            quality_range_from.forEach((el) => {
              el.removeAttribute('disabled')
            })
            quality_range_to.forEach((el) => {
              el.removeAttribute('disabled')
            })
            quality_range__slider.forEach((el) => {
              el.removeAttribute('disabled')
            })
          }
        }
      })
    }
  })
}

const filtersClearTrigger = () => {
  const dataFilterActive = document.querySelectorAll('[data-filter].is-active')
  bondFilterClears.forEach((el) => {
    if(dataFilterActive.length == 0){
      el.classList.remove('is-active')
      if (el.classList.contains('js__select')) {
        let list = el.options
        for (let i=0; i<list.length; i++) {
          list[i].selected = false
          list[i].classList.remove('is-active')
        }
      }
    }
    else{
      el.classList.add('is-active')
    }
  })
  years_to_maturity_checkbox()
  debounce(oTable.ajax.reload(), 500)
}

const filtersChangeHandler = (el, name) => {
  el.classList.toggle('is-active')
  const same_filters = document.querySelectorAll('[data-filter="' + el.dataset.filter + '"')
  if(same_filters) {
    same_filters.forEach((sf) => {
      if(sf != el && el.dataset.filter != 'Качество') {
        sf.classList.toggle('is-active')
        sf.setAttribute('data-applied-value', el.dataset.filter)
        filterApplyHandler(sf.dataset.filterOpenModal)
        if(sf.dataset.filter == 'Доступно для ИИС') {
          if(sf.classList.contains('is-active')) {
            sf.setAttribute('data-previous-filter', el.dataset.filter)
          }
          else {
            sf.setAttribute('data-previous-filter', 'default')
          }
        }
      }
      else if(el.dataset.filter == 'Качество') {
        let thisPosition = el.querySelector('.range__slider').noUiSlider.get()
        if(thisPosition[0] !== sf.querySelector('.range__slider').noUiSlider.get()[0] || thisPosition[1] !== sf.querySelector('.range__slider').noUiSlider.get()[1]) {
          sf.querySelector('.range__slider').noUiSlider.set([Number(el.querySelector('.range__slider').noUiSlider.get()[0]),Number(el.querySelector('.range__slider').noUiSlider.get()[1])])
        }
        if(sf != el) {
          sf.classList.add('is-active')
        }
        sf.setAttribute('data-applied-value', name)
        filterApplyHandler(sf.dataset.filterOpenModal)
      }
    })
  }
  let file = input.files[0]
  if (file && name == 'Загруженный портфель') {
    filterClearHandler(el.dataset.filter)
    filterSetHandler(el, name)
    el.classList.add('is-active')
  }

  if(el.classList.contains('is-active')){
    if (!el.classList.contains('yield_including_tax') && !el.classList.contains('js-load-xls-table')) {
      filterSetHandler(el, name)
    }
  }
  else{
    filterClearHandler(el.dataset.filter)
    if(el.dataset.filter == 'AA,AAA' || el.dataset.filter == 'A' || el.dataset.filter == 'BBB') {
      filterClearHandler('Надежные и качественные')
      quality_range_from.forEach((el) => {
        el.removeAttribute('disabled')
      })
      quality_range_to.forEach((el) => {
        el.removeAttribute('disabled')
      })
      quality_range__slider.forEach((el) => {
        el.removeAttribute('disabled')
      })
      filterApplyHandler('basic')
    }
  }
  iBondCheckbox.forEach((ibch) => {
    if (ibch.classList.contains('is-active')) {
      iBondRange[value__i].noUiSlider.on('update', function () {})
    }
  })
}

const filtersClear = (filters) => {
  filters.forEach((el) => {
    const prevFilt = el.dataset.previousFilter
    if(el.classList.contains('js__range')) {
      if(prevFilt == 'default') {
        el.querySelectorAll('.range__slider').forEach((el) =>  {
          el.noUiSlider.set([el.dataset.min,el.dataset.max])
        })
        inputRangeClearHandler(el)
        filterClearHandler(el.dataset.filter)
      }
      else {
        el.querySelectorAll('.range__slider').forEach((el) =>  {
          el.noUiSlider.set([prevFilt.split(' ')[prevFilt.split(' ').length - 3],prevFilt.split(' ')[prevFilt.split(' ').length - 1]])
        })
      }
    }
    else if(el.classList.contains('js__date')) {
      if(el.dataset.previousFilter == 'default') {
        inputRangeClearHandler(el)
        filterClearHandler(el.dataset.filter)
      }
      else {
        el.querySelector('.js__date-from').value = prevFilt.split(' ')[prevFilt.split(' ').length - 3]
        el.querySelector('.js__date-to').value = prevFilt.split(' ')[prevFilt.split(' ').length - 1]
        const name = `${el.dataset.filter} ${el.querySelector('.js__date-from').value} - ${el.querySelector('.js__date-to').value}`
        filterClearHandler(el.dataset.filter)
        filtersChangeHandler(el, name)
      }
    }
    else {
      if(typeof prevFilt === 'undefined' || prevFilt == '' || prevFilt == 'default') {
        el.classList.remove('is-active')
        filterClearHandler(el.dataset.filter)
      }
      else {
        if(!el.dataset.appliedValue) {
          el.dataset.appliedValue = prevFilt
          filtersChangeHandler(el, el.dataset.filter)
        }
        else {
          if(!el.classList.contains('is-active')) {
            el.classList.add('is-active')
          }
        }
      }
    }
  })
}

const default_columns = [
  0,2,3,4,6,7,8,9,10,13,14,15,16,18,20,21,22,23,25,26,27,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,46,47,48,49,50,51,52,53,
  54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76]
let visible_columns = default_columns

window.addEventListener('resize',(e) => {
  if (window.innerWidth <= 1024) {
    visible_columns = default_columns
    //сбросить активные чекбоксы
  }
});


const columnsHandler = (el) => {
  const columnIdx = el.dataset.column;
  const column = oTable.column(columnIdx);
  const header_cells = document.querySelectorAll('.bonds__table-head')
  const item_cells = document.querySelectorAll('.bonds__item-inner')
  let visible_length = document.querySelectorAll('.js__columns.is-active').length;

  if(el.classList.contains('is-active')) {
    // visible_length = visible_length - 1;
    visible_columns.splice(visible_columns.indexOf(columnIdx),1)
  }
  else {
    visible_length = visible_length + 2;
    visible_columns.push(columnIdx)
  }
  if(visible_length <= 12) {
    el.classList.toggle('is-active')
    header_cells.forEach(elem => {
      elem.style = 'grid-template-columns: repeat(' + visible_length + ', minmax(85px, 1.33fr));'
    });
    item_cells.forEach(elem => {
      elem.style = 'grid-template-columns: repeat(' + visible_length + ', minmax(85px, 1.33fr));'
    });
    column.visible(!column.visible());
  }
  // modalOpenBaseHandler()
  oTable.draw()
}

/* Применение фильтров */
if(bondFilters){
  bondFilters.forEach((el) => {
    if(el.classList.contains('js__range')){
      el.addEventListener('range', (e) => {
        let elname = el.dataset.filter
        const transferedRangesGet = el.querySelectorAll('.range__field')
        const currentRange = e.target
        bondFilters.forEach((el) => {
          const transferedRangesSet = el.querySelectorAll('.range__field')
          if (el.dataset.filter == elname) {
            if (transferedRangesSet.length > 0) {
              if(transferedRangesGet[1] && Number(transferedRangesSet[0].value) > Number(transferedRangesGet[1].value)) {
                transferedRangesSet[0].value = transferedRangesGet[1].value
                if(currentRange == el) {
                  currentRange.querySelector('.range__slider').noUiSlider.set([transferedRangesSet[0].value,null])
                }
              }
              else {
                if(Number(transferedRangesGet[0].value) < Number(transferedRangesGet[0].dataset.defaultValue)) {
                  transferedRangesGet[0].value = transferedRangesGet[0].dataset.defaultValue
                }
                if(transferedRangesGet[1] && Number(transferedRangesGet[0].value) > Number(transferedRangesGet[1].dataset.defaultValue)) {
                  transferedRangesGet[0].value = transferedRangesGet[1].dataset.defaultValue
                }
                transferedRangesSet[0].value = transferedRangesGet[0].value
              }
            }
            if (transferedRangesGet[1] && transferedRangesSet.length > 0) {
              if(Number(transferedRangesGet[1].value) > Number(transferedRangesGet[1].dataset.defaultValue)) {
                transferedRangesGet[1].value = transferedRangesGet[1].dataset.defaultValue
              }
              transferedRangesSet[1].value = transferedRangesGet[1].value
            }

              if (transferedRangesGet[0] && transferedRangesGet[0].classList.contains('js-best_score_input')) {
                let rename = 'Средние'
                if (transferedRangesGet[0].value == 0.9) {
                  rename = 'Узкая выборка'
                } else if (transferedRangesGet[0].value == 0.8) {
                  rename = 'Меньше бумаг'
                } else if (transferedRangesGet[0].value == 0.6) {
                  rename = 'Средние'
                } else if (transferedRangesGet[0].value == 0.4) {
                  rename = 'Больше бумаг'
                } else if (transferedRangesGet[0].value == 0.2) {
                  rename = 'Широкая выборка'
                }
                const bestScoreText = document.querySelectorAll('.js-best_score_text')
                bestScoreText.forEach( (b) => {
                  b.innerText = rename
                })
              }
            }
          })
          let v0 = transferedRangesGet[0].value
          let v1
          if (transferedRangesGet[1]) {
            v1 = transferedRangesGet[1].value
          }
          let name;
          if(e.detail.to){
            if (!isNaN(parseFloat(v0)) && isFinite(v0) && !isNaN(parseFloat(v1)) && isFinite(v1)) {
              name = `${el.dataset.filter} ${bonds.formatNumber(v0, 2)} - ${bonds.formatNumber(v1, 2)}`
            }
          }
          else{
            name = `${el.dataset.filter} ${bonds.formatNumber(e.detail.value, 2)}`
          }

          filterClearHandler(el.dataset.filter)
          filtersChangeHandler(el, name)
      })

    }
    else if(el.classList.contains('js__date')) {
      el.addEventListener('input', (e) => {
        const name = `${el.dataset.filter} ${el.querySelector('.js__date-from').value} - ${el.querySelector('.js__date-to').value}`
        filterClearHandler(el.dataset.filter)
        filtersChangeHandler(el, name)
      })
    }
    else if(el.classList.contains('js__select')) {
      el.addEventListener('change', (e) => {
        let curId = el.classList.contains('currency__id')
        let strId = el.classList.contains('strategy')
        const curBtn = document.querySelectorAll('.bonds__filters-tab_currency')
        const strBtn = document.querySelectorAll('.bonds__filters-tab_strategy')
        el.dataset.filter = e.target.value
        el.dataset.appliedValue = e.target.value
        Array.from(el.options).forEach((option) => {
          option.classList.remove('is-active')
        })
        el.options[el.selectedIndex].classList.add('is-active')
        let name = el.options[el.selectedIndex].dataset.filterName
        let selectClassList = el.classList

        filterClearHandler(el.dataset.filter, 'select', selectClassList)
        filtersChangeHandler(el, name)

        bondFilters.forEach((el) => {
          const curIdInner = el.classList.contains('js__currency_checkbox')
          const strIdInner = el.classList.contains('js__strategy_checkbox')
          const setActiveFilter = () => {
            if (el.dataset.filter == name) {
              el.classList.add('is-active')
            } else {
              el.classList.remove('is-active')
              filterClearHandler(el.dataset.filter)
            }
          }

          if (el.classList.contains('js__checkbox') && curId == curIdInner && curIdInner) {
            setActiveFilter()
          }

          if (el.classList.contains('js__checkbox') && strId == strIdInner && strIdInner) {
            setActiveFilter()
            }
          })

        if (curId && el.value != '-') {
          curBtn.forEach((el) => {
            el.setAttribute('disabled', true)
          })
        }
        if (curId && el.value == '-') {
          curBtn.forEach((el) => {
            el.removeAttribute('disabled')
          })
        }

        if (strId && el.value != '-') {
          strBtn.forEach((el) => {
            el.setAttribute('disabled', true)
          })
        }
        if (strId && el.value == '-') {
          strBtn.forEach((el) => {
            el.removeAttribute('disabled')
          })
        }

      })
    }
    else if (el.classList.contains('js__keyup')) {
      if (replacementInput && replacementSubmit) {
        replacementSubmit.forEach((rs, i) => {
        rs.addEventListener('click', (e) => {
            if (replacementInput[i].value) {
              filterClearHandler(el.dataset.filter)
              filtersChangeHandler(el, el.dataset.filter)
            } else {
              filterClearHandler(el.dataset.filter)
            }
          })
        })
      }
    }
    else if (el.classList.contains('js__columns')) {
      const bondsFilterClickHandler = () => {
        columnsHandler(el)
      }
      el.addEventListener('click', bondsFilterClickHandler )
    }
    else{
      const bondsFilterClickHandler = () => {
        if (el.classList.contains('js__checkbox-frnIndex')) {
          // const frnIndexBox = document.querySelectorAll('.js-bonds__range-frnIndex')
          // frnIndexBox.forEach((fib) => {
          //   fib.style.display = 'none'
          // })
          let frnRange = null
          if(el.dataset.filter != 'MIN(CBR_RATE+X;23%)' && el.dataset.filter != '1/2_CBR_RATE') {
            frnRange = document.querySelector('.js-' + el.dataset.filter)
          }
          if (frnRange) {
            frnRange.classList.add('active')
            // frnRange.querySelectorAll('.range__field').forEach((f) => {
            //   f.classList.add('is-active')
            // })
          }

          setTimeout(function() {
            let checkboxfrnIndex = document.querySelector('[data-filter="' + el.dataset.filter + '"]')
            if (checkboxfrnIndex && !checkboxfrnIndex.classList.contains('is-active') && frnRange) {
              frnRange.classList.remove('active')
              // frnRange.querySelectorAll('.range__field').forEach((f) => {
              //   f.classList.remove('is-active')
              // })
              const frnIndexAdd_range__slider = document.querySelectorAll('.frnIndexAdd_range')
              frnIndexAdd_range__slider.forEach((fiar) => {
                fiar.noUiSlider.set([fiar.dataset.min, fiar.dataset.max])
              })
              const frnIndexAdd = document.querySelector('.js-frnIndexAdd')
              filterClearHandler(frnIndexAdd.dataset.filter)
            }
          }, 500)

          let frnIndexAdd_from_arr = []
          let frnIndexAdd_to_arr = []
          let activeInputs = document.querySelectorAll(`.js_frnIndex-data.active`)
          activeInputs.forEach((ai) => {

            // if (ai.classList.contains('frnIndexAdd_from')) {
            //   let frnIndexAdd_from = ai
            // }
            // if (ai.classList.contains('frnIndexAdd_to')) {
            //   let frnIndexAdd_to = ai
            // }
            frnIndexAdd_from_arr.push(ai.dataset.frnIndexMin)
            frnIndexAdd_to_arr.push(ai.dataset.frnIndexMax)
            // let frnIndexAdd_from = ai.querySelector(`.frnIndexAdd_from.is-active`)
            // let frnIndexAdd_to = ai.querySelector(`.frnIndexAdd_to.is-active`)
            // frnIndexAdd_from.forEach((f) => {
            //   frnIndexAdd_from_arr.push(frnIndexAdd_from.value)
            // })
            // frnIndexAdd_to.forEach((t) => {
            //   frnIndexAdd_to_arr.push(frnIndexAdd_to.value)
            // })
            // console.log(frnIndexAdd_from);
            console.log(frnIndexAdd_from_arr);
            console.log(frnIndexAdd_to_arr);
            // data.customFilters['frnIndexAdd'] = {}
            let from = parseFloat(Math.min( ...frnIndexAdd_from_arr ))
            let to = parseFloat(Math.max( ...frnIndexAdd_to_arr ))
            const frnIndexAdd_range__slider = document.querySelectorAll('.frnIndexAdd_range')
            frnIndexAdd_range__slider.forEach((fiar) => {
              fiar.noUiSlider.set([0, to])
            })

          })


        }

        if (el.classList.contains('js-credit_rating')) {
          filterClearHandler('Надежные и качественные')
        }
        if (el.classList.contains('js__checkbox_ibond')) {
          ibondRangeContainer.forEach( (i) => {
            i.style.display = 'block'
          })
          iBondRange[value__i].noUiSlider.on('update', function () {})

        }

        filtersChangeHandler(el, el.dataset.filter)
        const removeFilters = document.querySelectorAll('[data-filter="'+el.dataset.filterRemove+'"]')
        removeFilters.forEach((elem) => {
          inputRangeClearHandler(elem)
          filterClearHandler(elem.dataset.filter)
        })

        if (el.classList.contains('js__checkbox_ibond') && !el.classList.contains('is-active')) {
          ibondRangeContainer.forEach( (i) => {
            i.style.display = 'none'
          })
          oTable.column(57).search('').draw()
        }
      }
      el.addEventListener('click', bondsFilterClickHandler )
    }
  })
}

if(bondFilterClears){
  bondFilterClears.forEach((el) => {
    el.addEventListener('click', () => {
      bondFilters.forEach((el) => {
        globalReset = true
        const btns = document.querySelectorAll('.js__toggle-btn')
        btns.forEach((el) => {
          el.removeAttribute('disabled')
        })
        if (el.classList.contains('js__select')) {
          let list = el.options
          for (let i=0; i<list.length; i++) {
            list[i].selected = false
            list[i].classList.remove('is-active')
          }
        }

        inputRangeClearHandler(el)
        filterClearHandler(el.dataset.filter)
      })
      if (el.dataset.filtersType == 'mobile') {
        bondFilterMobileModals.forEach((el) => {
          filterApplyClearHandler(el.dataset.filterModal)
        })
      }
      bondFilterLocalSearch.forEach((el) => {
        el.value = ''
        borrower_country__desktop.search()
        borrower_country__mobile.search()
      })

      const marketMapSection = document.querySelector('.js-market_map--section')
      marketMapSection.classList.remove('is-active')
      const dataTablesWrapper = document.querySelector('.dataTables_wrapper')
      dataTablesWrapper.style.display = 'block'
      const tableSortingMobile = document.querySelector('.bonds__table-sorting--mobile')
      tableSortingMobile.style.display = 'block'
      filterClearHandler('Карта рынка')
      oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=info' ).load()
      ibondRangeContainer.forEach( (i) => {
        i.style.display = 'none'
      })
      oTable.column(57).search('').draw()
      liquidity_only__checkbox(false)
      globalReset = false
      replacementModesContainer.forEach((rmc) => {
        rmc.classList.add('disabled')
      })
      replacementClearButton.style.display = 'none'
      filtersClearTrigger()

        const rusChkbox = document.querySelector('[data-filter="Россия"]');
        if (rusChkbox) {
          console.log(rusChkbox);
          rusChkbox.click();
        }

    })
  })
}

if(bondFilterMobileBtns){
  bondFilterMobileBtns.forEach((el) => {
    el.addEventListener('click', (e) => {
      bondFilterMobileModals.forEach((modal) => {
        if(modal.dataset.filterModal == el.dataset.filterOpen && !e.target.classList.contains("bonds-filter__modal-btn_clear")){
          modal.classList.add('is-active')
        }
      })
    })
  })
}

if(bondFilterAppliedClears){
  bondFilterAppliedClears.forEach((el) => {
    el.addEventListener('click', () => {
      if (ranges) {
        ranges.forEach((r) => {
          if (r.dataset.filterOpenModal == el.dataset.appliedClear) {
            inputRangeClearHandler(r)
            filterClearHandler(r.dataset.filter)
          }
        })
      }

      filterApplyClearHandler(el.dataset.appliedClear)
      if (el.dataset.appliedClear == 'basic') {
        filterApplyClearHandler('vpo')
        filterClearHandler('Доступно для ИИС')
        filterApplyClearHandler('liquidity')
        filterApplyClearHandler('factors')
        filterApplyClearHandler('qualities')
        filterApplyClearHandler('credit')
      }
      if (el.dataset.appliedClear == 'vpo') {
        filterApplyClearHandler('basic')
      }
    })
  })
}

if(bondFilterMobileCloses) {
  bondFilterMobileCloses.forEach((el) => {
    el.addEventListener('click', () => {
      bondFilterMobileModals.forEach((modal) => {
        if (modal.dataset.filterModal == el.dataset.filterClose) {
          modal.classList.remove('is-active');
          if (el.hasAttribute('data-filter-apply')) {
            if(modal.querySelectorAll('[data-applied-value]').length > 0){
              modal.querySelectorAll('[data-applied-value]').forEach((el) => {
                if(el.dataset.filter == 'Качество') {
                  document.querySelectorAll('[data-filter="' + el.dataset.filter + '"]').forEach((qual) => {
                    qual.dataset.previousFilter = el.dataset.appliedValue
                  })
                }
                else {
                  el.dataset.previousFilter = el.dataset.appliedValue
                }
              })
            }
            if(modal.querySelectorAll('[data-previous-filter]').length > 0){
              modal.querySelectorAll('[data-previous-filter]').forEach((el) => {
                if(!el.dataset.appliedValue) {
                  el.dataset.previousFilter = 'default'
                }
              })
            }
            filterApplyHandler(modal.dataset.filterModal)
            if (modal.dataset.filterModal == 'basic') {
              filterApplyHandler('vpo')
            }
            if (modal.dataset.filterModal == 'vpo') {
              filterApplyHandler('basic')
            }
          }
          else {
            if(modal.dataset.filterModal != 'basic') {
              filtersClear(modal.querySelectorAll('[data-filter-open-modal="' + modal.dataset.filterModal + '"]'))
              if(modal.dataset.filterModal == 'factors') {
                filterApplyHandler('factors')
              }
            }
          }
        }
      })

    })
  })
}

const oTable = $('.js-bonds__table')
  .DataTable({
    processing: true,
    serverSide: false,
    ajax: {
      url: '/assets/components/dohodbonds/connectorweb.php?action=info',
      type: 'POST',
      dataSrc:'',
      data: function (data, settings) {
        postData = bonds.dataFilterParams(data)
        // данные от фильтров POST'ом передаются в сниппет на бэке
        bonds.dataFilterParams(data)
      }
    },
    filter: true,
    order: [[24, 'desc']],
    pagingType: 'full_numbers',
    pageLength: 40,
    lengthMenu: [[50, 100, 250, -1], [50, 100, 250, 'Все']],
    createdRow: function (row, data, dataIndex) {
      $(row).addClass('bonds__item bonds__item-inner row_' + data.credit_rating + ' isin_' + data.xml_isin);
      $(row).find('td:not(.js-link_to_bond)').attr('data-open-isin',data.xml_isin)
    },
    columns: [
      // 0 ISIN
      { data: 'xml_isin',
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center'
      },
      // 1 Название
      {
        data: function ( row, type, val, meta ) {
          let qinvest_icon
          if ( row.isqualinvestors == 1 ) {
            qinvest_icon = '<span title="Для квалифицированных инвесторов"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><use href="assets/dist/img/sprite.svg#i-graduation-cap"></use></svg></span>  '
          } else if ( row.is_qualify == 1 ) {
            qinvest_icon = '<span title="Для квалифицированных инвесторов"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><use href="assets/dist/img/sprite.svg#i-graduation-cap"></use></svg></span> '
          } else {
            qinvest_icon = ''
          }
          return qinvest_icon + row.name + bonds.spec_indicator(row)
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center shortname name bonds__item-title'
      },
      // 2 Эмитент
      { data: 'emitent' },
      // 3 Основной заемщик
      { data: function ( row, type, val, meta ) { return row.borrower != 'Array' ? row.borrower : 'n/a' } },
      // 4 Страна заемщика
      { data: 'borrower_country',
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center'
      },
      // 5 Валюта
      {
        data: 'currency',
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center bonds__item-currency currency'
      },
      // 6 Объем выпуска в обращении, млрд
      {
        data: function ( row, type, val, meta ) {
          if(row.value_of_emission != 0) {
            return bonds.formatNumber(row.value_of_emission,2)
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [58],
      },
      // 7 Ближайшая дата погашения/оферты (Дата)
      {
        data: function ( row, type, val, meta ) {
          return bonds.convertDate(row.effective_date)
        }
      },
      // 8 Лет до даты
      {
        data: function ( row, type, val, meta ) {
            return bonds.formatNumber(row.years_to_maturity, 1)
        }
      },
      // 9 Дюрация
      {
        data: function ( row, type, val, meta ) {
            return ((row.duration != null && row.duration != 0) ? bonds.formatNumber(row.duration, 2) : bonds.formatNumber(row.mod_duration, 2))
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
      },
      // 10 Событие в дату
      {
        data: function ( row, type, val, meta ) {
            return (row.event != undefined ? row.event : '-')
        }
      },
      // 11 Дата / Срок, лет / Событие
      {
        data: function ( row, type, val, meta ) {
          let bbdate =  '-';
            bbdate = row.effective_date

          return '<div class="no_export"><div class="bonds__item-date_mobile">'+bonds.formatNumber(row.years_to_maturity, 1) +
            ' лет до: ' + (row.event != undefined ? row.event : '-')+'</div>' +
            '<span>'+bonds.convertDate(bbdate) + ' / ' + bonds.formatNumber(row.years_to_maturity, 1) +
            ' / ' + (row.event != undefined ? row.event : '-')+'</span></div>';
        },
        render: function (data, type, full, meta) {
          if (data != null && data != '0000-00-00')
            return data
          else
            return '<div class="no_export"><div class="bonds__item-subtitle">Дата / Срок, лет / Событие</div>' +
              '<span>n/a</span></div>'
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-left effective_date years_to_maturity event bonds__item-date no_export',
        orderData: [49],
      },
      // 12 эффективная доходность
      {
        data: function ( row, type, val, meta ) {
          let yield_value = ''
            yield_value = row.price_return

          yield_value = yield_value + ' ' + row.not_reinvesting
          return yield_value
        },
        render: function (data, type, full, meta) {
          let data_yield = data.split(' ')[0]
          let data_not_reinvesting = data.split(' ')[1]

          return '<div class="bonds__item-yield"><div class="bonds__item-subtitle">Доходность</div><span class="yield_price_return">' +
              (!not_reinvesting_checkbox() ? (parseFloat(data_yield) ? bonds.formatNumber(data_yield, 1) : 'n/a') : (parseFloat(data_not_reinvesting) ? bonds.formatNumber(data_not_reinvesting, 1) : 'n/a')) +
              '</span><span class="yield_price_return_recount"></span><span class="yield_hidden" hidden>yield' + bonds.formatNumber(data_yield, 1) + '</span></div>';
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center yield price_return bonds__item-profitability',
        orderData: [48],
      },
      // 13 Примерная доходность без реинвестирования, %
      {
        data: function ( row, type, val, meta ) {
          if(row.not_reinvesting != null) {
            return row.not_reinvesting
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [59],
      },
      // 14 Доля прибыли от реинвестирования (к погашению)
      {
        data: function ( row, type, val, meta ) {
          if(row.reinvesting != null) {
            return row.reinvesting
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [60],
      },
      // 15 Простая доходность, %
      {
        data: function ( row, type, val, meta ) {
          if(row.fact_yield != null) {
            return row.fact_yield
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [61],
      },
      // 16 Текущая доходность, %
      {
        data: function ( row, type, val, meta ) {
          if(row.calc_current_yield != null) {
            return bonds.formatNumber(row.calc_current_yield, 2)
          }
          else {
            return ((row.current_yield != null) ? bonds.formatNumber(row.current_yield, 2) : 'n/a')
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [56],
      },
      // 17 Кредитное качество
      {
        data: 'credit_rating_text',
        className: 'dt-center credit_rating_text bonds__item__cell-credit',
        orderData: [18],
        render: function (data, type, full, meta) {
          if (data == '' || data == null)
            return '<div class="bonds__item-credit is-grey"><div class="bonds__item-subtitle">Кредитное качество</div><span>n/a</span></div>';
          return '<div class="bonds__item-credit"><div class="bonds__item-subtitle">Кредитное качество</div><span>'+data+'</span></div>';
        },
        createdCell: function (td, cellData, rowData, row, col) {
          bonds.creditRatingTextCellStyle(td, cellData)
          $(td).attr('data-open-isin',rowData.xml_isin)
        }
      },
      // 18 Кредитное качество (число, max=10) (сортировка для кредитного качества)
      { data: 'credit_rating' },
      // 19 Качество эмитента
      {
        data: 'quality',
        className: 'dt-center quality bonds__item__cell-quality',
        type: 'number',
        orderData: [50],
        render: function (data, type, full, meta) {
          return '<div class="bonds__item-quality"><div class="bonds__item-subtitle">Качество эмитента</div><span>'+bonds.formatNumber(data, 1)+'</span></div>';
        },
        createdCell: function (td, cellData, rowData, row, col) {
          bonds.qualityCellStyle(td, cellData)
          $(td).attr('data-open-isin',rowData.xml_isin)
        }
      },
      // 20 Inside Q (max=10)
      {
        data: function ( row, type, val, meta ) {
          if(row.q_in != null)
            return bonds.formatNumber(row.q_in,2)
          return 'n/a'
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [68],
      },
      // 21 Outside Q (max=10)
      {
        data: function ( row, type, val, meta ) {
          if(row.q_out != null)
            return bonds.formatNumber(row.q_out,2)
          return 'n/a'
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [69],
      },
      // 22 NetDebt/Equity (рейтинг) (max=10)
      {
        data: function ( row, type, val, meta ) {
          if(row.q_ratingnetdebt_equity != null) {
            return bonds.formatNumber(row.q_ratingnetdebt_equity,1)
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [62],
      },
      // 23 NetDebt/Equity (знач)
      {
        data: function ( row, type, val, meta ) {
          if(row.q_valuenetdebt_equity != null) {
            return bonds.formatNumber(row.q_valuenetdebt_equity,1)
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        orderData: [70],
        className: 'no_export dt-center'
      },
      // 24 Ликвидность
      {
        className: 'dt-center liquidity bonds__item__cell-liquidity',
        type: 'string',
        data: function ( row, type, val, meta ) {
          return '<div class="bonds__item-liquidity"><div class="bonds__item-subtitle">Ликвидность</div><span>'+
             bonds.formatNumber(row.liquidity_xml, 1) +'</span></div>';
        },
        createdCell: function (td, cellData, rowData, row, col) {
          let cell_data = parseInt(cellData.match(/\d+/))
          if ( cell_data >= 80 ) {
            td.children[0].classList.add('is-green');
          }
          else if ( cell_data >= 70 && cell_data < 80 ) {
            td.children[0].classList.add('is-b-green');
          }
          else if ( cell_data >= 60 && cell_data < 70 ) {
            td.children[0].classList.add('is-l-green');
          }
          else if ( cell_data >= 50 && cell_data < 60 ) {
            td.children[0].classList.add('is-blue');
          }
          else if ( cell_data >= 30 && cell_data < 50 ) {
            td.children[0].classList.add('is-l-red');
          }
          else if ( cell_data >= 0 && cell_data < 30 ) {
            td.children[0].classList.add('is-red')
            td.children[0].style.color = 'white'
          }
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        orderData: [71],
      },
      // 25 Медиана дневного оборота (млн) (в валюте торгов)
      {
        data: function ( row, type, val, meta ) {
          if(row.vol_median != null && row.vol_median != 0) {
            return row.vol_median
          }
          else {
            return 'n/a'
          }
        },
        className: 'dt-center',
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        orderData: [74],
      },
      // 26 Сложность (max=5)
      {
        data: function ( row, type, val, meta ) {
          if(row.complexity != null) {
            return row.complexity
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [63],
      },
      // 27 Размер (max=10)
      {
        data: function ( row, type, val, meta ) {
          if(row.size != null) {
            return row.size
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [64],
      },
      // 28 Рыночный риск
      {
        data: 'down_risk',
        orderData: [51],
        render: function (data, type, full, meta) {
          if (data == 0)
            return '<div><div class="bonds__item-subtitle">Рыночный риск</div><span>n/a</span></div>';
          if (data == 'Array')
            return '<div><div class="bonds__item-subtitle">Рыночный риск</div><span>n/a</span></div>';
          return '<div><div class="bonds__item-subtitle">Рыночный риск</div><span>'+bonds.formatNumber(data, 1)+'</span></div>';
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center down_risk bonds__item-market no_export',
        type: 'num'
      },
      // 29 дата выпуска
      {
        data: function ( row, type, val, meta ) {
          if (row.issue_date != null) {
            return '<div style="width: 100px;">' + bonds.convertDate(row.issue_date) + '</div>';
          } else {
            return '-';
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [54]
      },
      // 30 Дата погашения
      {
        data: function ( row, type, val, meta ) {
            if (row.maturity_date != '' && row.maturity_date != null) {
              return '<div style="width: 100px;">' + bonds.convertDate(row.maturity_date) + '</div>';
            }
            else {
              return 'n/a';
            }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [55]
      },
      // 31 Дата, к которой рассчитывается доходность
      {
        data: function ( row, type, val, meta ) {
          if (row.effective_date == row.maturity_date) {
            return '-';
          } else {
            return '<div style="width: 100px;">' + bonds.convertDate(row.effective_date) + '</div>';
          }
        }
      },
      // 32 Текущий номинал
      {
        data: function ( row, type, val, meta ) {
            if(row.nominal != null) {
              return bonds.formatNumber(row.nominal, 2)
            }
            else {
              return 'n/a'
            }
        },
        className: 'dt-center',
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        orderData: [65]
      },
      // 33 Минимальный лот
      { data: 'minlot' },
      // 34 Цена, % от номинала
      {
        data: function ( row, type, val, meta ) {
            if(row.price != null && !isNaN(row.price)) {
              return bonds.formatNumber(row.price,2)
            }
            else {
              return '-'
            }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
      },
      // 35 НКД
      {
        data: function ( row, type, val, meta ) {
           if(row.nkd != null && !isNaN(row.nkd)) {
              return bonds.formatNumber(row.nkd,2)
            }
            else {
              return 'n/a'
            }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [66]
      },
      // 36 Размер купона
      {
        data: function ( row, type, val, meta ) {
          if(row.coupon != null && !isNaN(row.coupon)) {
            return bonds.formatNumber(row.coupon, 2)
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
        orderData: [67]
      },
      // 37 Текущий купон, %
      { data: function ( row, type, val, meta ) { return (row.current_coupon_prc != null ? bonds.formatNumber(row.current_coupon_prc,2) : '') },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
      },
      // 38 Купон (раз/год)
      {
        data:  function ( row, type, val, meta ) {
            if (row.coupon_period) {
              return row.coupon_period
            } else {
              return 'особое расписание'
            }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center',
      },
      // 39 Тип купона
      { data: function ( row, type, val, meta ) { return bonds.coupon_type_text_foo(row) } },
      // 40 Субординированная (да/нет)
      { data: function ( row, type, val, meta ) { return row.seniority == 4 ? 'да' : 'нет' } },
      // 41 С гарантией (да/нет)
      { data: function ( row, type, val, meta ) { return row.guarantor_type != 0 ? 'да' : 'нет' } },
      // 42 Отрасль
      { data: function ( row, type, val, meta ) { return (row.sector_text != 'Array' && row.sector_text != null) ? row.sector_text : 'n/a' },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'no_export'
      },
      // 43 Тип эмитента
      { data: 'emitent_type' },
      // 44 Привязка к индексу
      {
        type: 'string',
        data: function ( row, type, val, meta ) {
          let res
          if (row.frnIndex != null && row.frnIndex != '') {
            if (row.frnIndexAdd != null) {
              if (row.frnIndexAdd < 0) {
                res = row.frnIndex + ' - ' + row.frnIndexAdd
              } else {
                res = row.frnIndex + ' + ' + row.frnIndexAdd
              }
            } else {
              res = row.frnIndex
            }
          } else {
            res = 'n/a'
          }
          return res
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'dt-center no_export',
        orderData: [73]
      },
      // 45 Ссылка на отдельную облигацию
      { data: function ( row, type, val, meta ) { return link_to_bond(row) },
        orderable: false,
        className: 'js-link_to_bond bonds__item__cell-link_to_bond dt-center no_export' },
      // 46 Эффективная доходность к погашению, %
      {
        data: function ( row, type, val, meta ) {
          if(row.ytmMatCalc != null && row.ytmMatCalc != 0) {
            return bonds.formatNumber(row.ytmMatCalc, 1)
          }
          else {
            return 'n/a'
          }
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'no_export dt-center',
        orderData: [75],
      },
      // 47 Оценка облигации
      {
        data: function ( row, type, val, meta ) {
          return bonds.estimate_rating(row)
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        className: 'estimate_rating no_export dt-center',
        orderData: [76],
      },
      // 48 Доходность (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(!not_reinvesting_checkbox()) {
              return row.price_return
          }
          else {
            if ( row.not_reinvesting != null ) {
              return parseFloat(row.not_reinvesting)
            } else {
              return 0
            }
          }
        },
        className: 'no_export'
      },
      // 49 Ближайшая дата погашения/оферты (поле для сортировки)
      {
        data: 'effective_date',
        className: 'no_export',
        type: 'string'
      },
      // 50 Качество эмитента (поле для сортировки)
      {
        data: 'quality',
        type: 'num-fmt',
        className: 'no_export'
      },
      // 51 Рыночный риск (поле для сортировки)
      {
        data: 'down_risk',
        type: 'num-fmt',
        className: 'no_export'
      },
      // 52 Дюрация (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          return bonds.formatNumber(row.mod_duration, 2)
        },
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).attr('data-open-isin',rowData.xml_isin)
        },
        type: 'num-fmt',
        className: 'no_export'
      },
      // 53 Срок, лет (поле для сортировки)
      {
        data: 'years_to_maturity',
        type: 'num-fmt',
        className: 'no_export'
      },
      // 54 дата выпуска (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          let isdate =  '-';
          if (row.issue_date != null) {
            isdate = row.issue_date
          }
          return isdate
        },
        className: 'no_export',
        type: 'string'
      },
      // 55 дата погашения (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          let mdate =  '-';
            if (row.maturity_date != '' && row.maturity_date != null) {
              mdate = row.maturity_date;
            }
          return mdate
        },
        className: 'no_export',
        type: 'string'
      },
      // 56 Текущая доходность (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.calc_current_yield != null && row.calc_current_yield != 0) {
            return row.calc_current_yield
          }
          else {
            return ((row.current_yield != null && row.current_yield != 0) ? row.current_yield : 0)
          }
        },
        className: 'no_export'
      },
      // 57 best_score (поле для фильтрации)
      {
        data: 'best_score',
        type: 'num-fmt',
        className: 'no_export'
      },
      // 58 Объем выпуска в обращении, млрд (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.value_of_emission != 0) {
            return bonds.formatNumber(row.value_of_emission,2)
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 59 Примерная доходность без реинвестирования, % (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.not_reinvesting != null) {
            return row.not_reinvesting
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 60 Доля прибыли от реинвестирования (к погашению) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.reinvesting != null) {
            return row.reinvesting
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 61 Простая доходность, % (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.fact_yield != null) {
            return row.fact_yield
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 62 NetDebt/Equity (рейтинг) (max=10) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.q_ratingnetdebt_equity != null) {
            return bonds.formatNumber(row.q_ratingnetdebt_equity,1)
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 63 Сложность (max=5) (max=10) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.complexity != null) {
            return row.complexity
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 64 Размер (max=10) (max=10) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.size != null) {
            return row.size
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 65 Текущий номинал (max=10) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
            if(row.nominal != null) {
              return bonds.formatNumber(row.nominal, 2)
            }
            else {
              return '-'
            }
        },
        className: 'no_export',
      },
      // 66 НКД (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
            if(row.nkd != null && !isNaN(row.nkd)) {
              return bonds.formatNumber(row.nkd,2)
            }
            else {
              return '-'
            }
        },
        className: 'no_export',
      },
      // 67 Размер купона (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.coupon != null && !isNaN(row.coupon)) {
            return bonds.formatNumber(row.coupon, 2)
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 68 Inside Q (max=10) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          return bonds.formatNumber(row.q_in,2)
        },
        className: 'no_export',
      },
      // 69 Outside Q (max=10) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          return bonds.formatNumber(row.q_out,2)
        },
        className: 'no_export',
      },
      // 70 NetDebt/Equity (знач) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.q_valuenetdebt_equity != null) {
            return bonds.formatNumber(row.q_valuenetdebt_equity,1)
          }
          else {
            return '-'
          }
        },
        className: 'no_export'
      },
      // 71 Ликвидность (знач) (поле для сортировки)
      {
        type: 'num',
        data: 'liquidity_xml',
        className: 'no_export'
      },
      // 72 Базовый индекс (для FRN) (поле для выгрузки)
      {
        title: 'Базовый индекс (для FRN)',
        type: 'string',
        data: 'frnIndex'
      },
      // 73 Премия/Дисконт к базовому индексу (для FRN) (поле для сортировки)
      {
        title: 'Премия/Дисконт к базовому индексу (для FRN)',
        type: 'num',
        data: 'frnIndexAdd'
      },
      // 74  Медиана дневного оборота (млн) (в валюте торгов) (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.vol_median != null && row.vol_median != 0) {
            return bonds.formatNumber(row.vol_median, 2)
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 75  Эффективная доходность к погашению (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.ytmMatCalc != null) {
            return bonds.formatNumber(row.ytmMatCalc, 1)
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
      // 76  Оценка облигации (поле для сортировки)
      {
        data: function ( row, type, val, meta ) {
          if(row.estimationRating != null) {
            return row.estimationRating
          }
          else {
            return '-'
          }
        },
        className: 'no_export',
      },
    ],
    columnDefs: [{
      targets: visible_columns,
      visible: false
    }],
    language: {
      search: 'Поиск:',
      loadingRecords: '<div class="bonds__preloader-overlay"><div class="bonds__preloader"><div class="bonds__preloader-inner"></div></div></div>',
      processing: '<div class="bonds__preloader-overlay"><div class="bonds__preloader"><div class="bonds__preloader-inner"></div></div></div>',
      // lengthMenu: "Показывать _MENU_ строк в таблице",
      lengthMenu: '<div class="bonds__control bonds__rows_count"><span>Строк в таблице</span><select class="js__slim_select">' +
        '<option value="15">15</option><option value="25">25</option><option value="40">40</option>' +
        '</select></div>',
      zeroRecords: 'Нет данных для отображения',
      info: '<div class="wrapper-p">Показаны строки с _START_ по _END_. Отфильтровано _TOTAL_ строк</div>',
      infoFiltered: 'из _MAX_',
      infoEmpty: 'Таких облигаций пока нет в сервисе. Попробуйте готовые выборки в Базовых стратегиях',
      paginate: {
        first: '',
        previous: '<span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg"><use href="/assets/dist/img/sprite.svg#i-arrow-left"></use></svg></span>',
        next: '<span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg"><use href="/assets/dist/img/sprite.svg#i-arrow-right"></use></svg></span>',
        last: ''
      },
      aria: {
        sortAscending: ': активировать для сортировки столбца по возрастанию',
        sortDescending: ': активировать для сортировки столбца по убыванию'
      }
    },
    drawCallback: function(settings, json) {
      const modalsOpensBtns = document.querySelectorAll('[data-open-isin]')
      if (modalsOpensBtns) {
        modalsOpensBtns.forEach((mob) => {
          mob.addEventListener('click', (e) => {
            let dohodModal = document.getElementsByTagName('dohod-modal')
            if(dohodModal.length > 0) {
              dohodModal[0].remove()
            }
            let element = document.createElement('dohod-modal')
            document.body.appendChild(element)
            // Установка id для поиска компонента по нему
            element.setAttribute('isin', mob.dataset.openIsin)
            // Открытие модального окна
            element.setAttribute('opened', true)
            // Подписка на события
            element.addEventListener('close-modal', closeModal)
            element.addEventListener('open-modal', initModalComponents)

          })
        })
      }
      const item_cells = document.querySelectorAll('.bonds__item-inner')
      let visible_length = document.querySelectorAll('.js__columns.is-active').length + 1;
      item_cells.forEach((elem, i) => {
        elem.style = 'grid-template-columns: repeat(' + visible_length + ', minmax(85px, 1.33fr));'
        if (i === 4) {
          /*if((Math.floor(Math.random() * 10) + 1) < 5) {
            bannerBetweenRows(elem, 'bnd')
          }
          else {
            bannerBetweenRows(elem, 'wild')
          }*/
          // bannerBetweenRows(elem, 'bnd')
        }
      });
      replacementInput.forEach((rpmi) => {
        const rmival = rpmi.value
        if (rmival) {
          const isinTextRow = document.querySelector('.isin_' + rmival)
          if (isinTextRow) {
            isinTextRow.classList.add('highLightedRow')
          }
        }
      })

      const infoRow = document.getElementById('DataTables_Table_0_info')
      const loaded = document.createElement('span')
      loaded.className = 'loaded'
      loaded.setAttribute('hidden', '')
      loaded.innerText = 'loaded'
      infoRow.appendChild(loaded)
      setTimeout(() => {
        if (infoRow.querySelector('.loaded')) {
          infoRow.querySelector('.loaded').remove()
        }
      }, 2000)
    },
})

const bannerBetweenRows = (elem, type) => {
  const newDiv = document.createElement('div')
  newDiv.className = 'bonds-' + type + '_ETF'
  const newDivTitle = document.createElement('div')
  newDivTitle.className = 'bonds-' + type + '_ETF_title'
  /*if(type === 'bnd') {
    newDivTitle.textContent = 'Отобрали облигации за вас'
  }
  else {
    newDivTitle.innerHTML = 'Отбираете бумаги сами? </br>Попробуйте готовый фонд акций WILD ETF'
  }*/
  newDivTitle.textContent = 'Отобрали облигации за вас'
  const img1 = document.createElement('img')
  const img2 = document.createElement('img')
  const img3 = document.createElement('img')
  const img4 = document.createElement('img')
  const img5 = document.createElement('img')
  img1.src = '/assets/src/assets/img/promo-banners/bonds_' + type + '_etf_mobile.png'
  img2.src = '/assets/src/assets/img/promo-banners/bonds_' + type + '_etf_tablet.png'
  img3.src = '/assets/src/assets/img/promo-banners/bonds_' + type + '_etf_desktop.png'
  img4.src = '/assets/src/assets/img/promo-banners/bonds_' + type + '_etf_tablet_sm.png'
  img5.src = '/assets/src/assets/img/promo-banners/bars.png'
  img1.className = 'bonds_' + type + '_img_mobile'
  img2.className = 'bonds_' + type + '_img_tablet'
  img3.className = 'bonds_' + type + '_img_desktop'
  img4.className = 'bonds_' + type + '_img_tablet_sm'
  img5.className = 'bonds_' + type + '_img_mobile_bars'
  const link = document.createElement('a')
  /*if(type === 'bnd') {
    link.textContent = 'Посмотреть портфели'
    link.href = '/news/etf-obligatsii-s-tselevoi-datoi?erid=2SDnjee4tNq'; // Замените на нужный URL
    link.setAttribute('onclick', "ym(10543570,'reachGoal','obligatsiiallbnd')");
  }
  else {
    link.textContent = 'Посмотреть параметры'
    link.href = '/individuals/mutual-funds/bpif/wild?erid=2SDnjeqx9UH'; // Замените на нужный URL
    link.setAttribute('onclick', "ym(10543570,'reachGoal','wildobligatsii')");
  }*/
  link.textContent = 'Посмотреть портфели'
  link.href = '/news/etf-obligatsii-s-tselevoi-datoi?erid=2SDnjee4tNq'; // Замените на нужный URL
  link.setAttribute('onclick', "ym(10543570,'reachGoal','obligatsiiallbnd')");

  newDiv.appendChild(newDivTitle)
  newDiv.appendChild(img3)
  newDiv.appendChild(link)
  newDiv.appendChild(img1)
  newDiv.appendChild(img2)
  /*if(type === 'wild') {
    newDiv.appendChild(img4)
    newDiv.appendChild(img5)
  }*/
  elem.insertAdjacentElement('afterend', newDiv)
}

const slimSelects = document.querySelectorAll('.js__slim_select')
if(slimSelects) {
  slimSelects.forEach((el) => {
    new SlimSelect({
      select: el,
      showSearch: false,
      showContent: 'down',
      hideSelectedOption: true,
      settings: {
        contentPosition: 'fixed'
      },
    })
  })
}

if(ranges){
  ranges.forEach((el) => {
    const rangeSlider = el.querySelector('.range__slider')
    const rangeControls = el.querySelectorAll('.range__field')
    let slider
    if(rangeSlider && rangeSlider.hasAttribute('data-multiply')){
      slider = noUiSlider.create(rangeSlider, {
        start: [Number(rangeSlider.dataset.min), Number(rangeSlider.dataset.max)],
        connect: true,
        tooltips: false,
        range: {
          'min': Number(rangeSlider.dataset.from),
          'max': Number(rangeSlider.dataset.to)
        },
      })
    } else if(rangeSlider && rangeSlider.hasAttribute('data-multiply-rounded')){
      slider = noUiSlider.create(rangeSlider, {
        start: [Number(rangeSlider.dataset.min), Number(rangeSlider.dataset.max)],
        connect: true,
        step: 1,
        tooltips: false,
        range: {
          'min': Number(rangeSlider.dataset.from),
          'max': Number(rangeSlider.dataset.to)
        },
      })
    } else if(rangeSlider && rangeSlider.hasAttribute('data-stepped')){
      slider = noUiSlider.create(rangeSlider, {
        start: [Number(rangeSlider.dataset.min), Number(rangeSlider.dataset.max)],
        connect: true,
        tooltips: false,
        range: {
          'min': [Number(rangeSlider.dataset.from),2],
          '20%': [5,5],
          '50%': [50,50],
          'max': Number(rangeSlider.dataset.to)
        },
        pips: {
          mode: 'values',
          values: [1,2,3,4,5,10, 20,30,50,100,150,200, Number(rangeSlider.dataset.max)],
          density: 10,
          filter: function (value,type) {
            return -1
          },
          stepped: true
        }
      })
    }
    else if (rangeSlider && rangeSlider.hasAttribute('data-single-step')){
      const arbitraryValuesForSlider = ['0.9', '0.8', '0.6', '0.4', '0.2']
      const format = {
        to: function(value) {
          return arbitraryValuesForSlider[Math.round(value)]
        },
        from: function (value) {
          return arbitraryValuesForSlider.indexOf(value)
        }
      }
      slider = noUiSlider.create(rangeSlider, {
        start: 0.6,
        range: { min: 0, max: arbitraryValuesForSlider.length - 1 },
        step: 1,
        pips: {
          mode: 'steps',
          format: format,
          density: 50
        },
        format: format,
      })
    }

    if (rangeSlider) {
      slider.on(`update`, (values, handle) => {
        const value = values[handle]
        if (rangeControls[handle]) {
          if (rangeSlider.dataset.inputSetFirst == 'false' || rangeSlider.dataset.inputSetFirst == undefined) {
            if (
              rangeControls[handle].classList.contains('couponperiod_to') == true ||
              rangeControls[handle].classList.contains('couponperiod_from') == true ||
              rangeControls[handle].classList.contains('complexity_from') == true ||
              rangeControls[handle].classList.contains('complexity_to') == true
            ) {
              rangeControls[handle].value = bonds.formatNumber(value, 0)
            } else {
              rangeControls[handle].value = bonds.formatNumber(value, 2)
            }
          }
          if (rangeSlider.hasAttribute('data-single-step')) {
            const percentileReDraw = () => {
              iBondCheckbox.forEach((ibch) => {
              if (ibch.classList.contains('is-active')) {
                if (values[0]) {
                    const obj = oTable.rows().data()
                    let bestScoreValuesArray = bonds.percentileSLiderUpdate(values[0], obj)
                    let bestScoreValuesString = bestScoreValuesArray.join('|')
                    oTable.column(57).search(bestScoreValuesString,true).draw()
                  }
                }
              })
            }
            setTimeout(percentileReDraw, 500)
          }
        }
      })
      slider.on(`set`, (values) => {
        let rangeObj
        if (values.length > 1) {
          rangeObj = {
            from: values[0],
            to: values[1]
          }
        } else {
          rangeObj = {
            value: values[0]
          }
        }
        el.dispatchEvent(new CustomEvent('range', {
          detail: rangeObj
        }));
        rangeSlider.setAttribute('data-input-set-first', 'false')
      })
      const rangeSet = debounce(function (e, index) {
        if (rangeSlider.hasAttribute('data-multiply') || rangeSlider.hasAttribute('data-stepped')) {
          switch (index) {
            case 0:
              slider.set([e, null])
              break;
            default:
              slider.set([null, e])
          }
        } else {
          slider.set(e)
        }
      }, 500);
      rangeControls.forEach((control, index) => {
        control.addEventListener('input', (e) => {
          if (e.target.value != '') {
            rangeSet(e.target.value, index)
            rangeSlider.setAttribute('data-input-set-first', 'true')
          }
        })
      })
    }
  })
}

if (loadXlsButton) {
  loadXlsButton.addEventListener('click', (e) => {
    oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=portfolio' ).load()
  })
  loadXlsButton.addEventListener('touchstart', (e) => {
    oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=portfolio' ).load()
  })
}

if (replacementInput && replacementSubmit) {
  replacementSubmit.forEach((el, i) => {
    el.addEventListener('click', (e) => {
      if (replacementInput[i].value) {
        replacementModesContainer.forEach((rmc) => {
          rmc.classList.remove('disabled')
        })
        let replacementModes = []
        replacementModesContainer.forEach((rmc) => {
          rmc.querySelectorAll('input').forEach((rmci) => {
            replacementModes.push(rmci)
          })
        })
        const rmival = replacementInput[i].value
        if (replacementModes) {
          replacementModes.forEach((el, i) => {
            el.parentNode.classList.remove('is-active')
            if (i >2) {
              replacementModes[3].parentNode.classList.add('is-active')
            } else {
              replacementModes[0].parentNode.classList.add('is-active')
            }
          })
        }
        oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=replacement&isin=' + rmival + '&mode=regular' ).load()
        oTable.order( [ 44, 'desc' ] ).draw()
        replacementClearButton.style.display = 'block'
      } else {
        replacementModesContainer.forEach((rmc) => {
          rmc.classList.add('disabled')
        })

        oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=info' ).load()
        replacementClearButton.style.display = 'none'
      }
    })
  })
  replacementInput.forEach((ri) => {
    ri.addEventListener('keyup', (e) => {
      if (ri.value) {
        replacementClearButton.style.display = 'block'
      } else {
        oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=info' ).load()
        replacementClearButton.style.display = 'none'
      }
    })
  })
  let replacementModes = []
  replacementModesContainer.forEach((rmc) => {
    rmc.querySelectorAll('input').forEach((rmci) => {
      replacementModes.push(rmci)
    })
  })
  if (replacementModes) {
    replacementModes.forEach((el, i) => {
      el.addEventListener('change', function() {
        let riv
        if (i >2) {
          riv = replacementInput[1].value
        } else {
          riv = replacementInput[0].value
        }
        if (riv) {
          replacementModes.forEach((el) => {
            el.parentNode.classList.remove('is-active')
          })

        this.parentNode.classList.add('is-active')
        oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=replacement&isin=' + riv + '&mode='+ this.value ).load()
        if (this.value == 'regular') {
          oTable.order( [ 44, 'desc' ] ).draw()
        } else {
          oTable.order( [ 49, 'asc' ] ).draw()
        }
      }
    })
  })
}
/* очистка поля ввода исина для поиска замены */
  replacementClearButton.addEventListener('click', function (e) {
    replacementInput[0].value = ''
    replacementClearButton.style.display = 'none'
    filterClearHandler('Подбор замены')
    oTable.ajax.url( '/assets/components/dohodbonds/connectorweb.php?action=info' ).load()
    replacementModesContainer.forEach((rmc) => {
      rmc.classList.add('disabled')
    })

  })

}

const replacementsInMainTable = (rowData) => {
  const replacementMainTable = document.querySelector('.js-replacement-main-table')
  if (replacementMainTable) {
    replacementMainTable.addEventListener('click', (e) => {
      replacementClearButton.click()
      replacementInput.forEach((ri) => {
        ri.value = rowData.xml_isin
      })
      const replacementModesContainerModal = document.querySelector('.js-mode-replacement-modal')
      const replacementModesModal = replacementModesContainerModal.querySelectorAll('input')
      if (replacementModesModal) {
        let filterbtn;
        replacementModesModal.forEach((el) => {
          if(el.parentNode.classList.contains('is-active')) {
            const rmci = replacementModesContainer[0].querySelectorAll('input')
            rmci.forEach((item) => {
              if(item.value == el.value) {
                filterbtn = item.parentNode
              }
            })
          }
        })
        replacementSubmit[0].click()
        filterbtn.click()
      }
    })
  }
}

oTable.on( 'draw', function () {
  // modalOpenBaseHandler()
  const yieldIncludingTaxInput = document.querySelector('.js-yield_including_tax__input')
  const yieldIncludingTax = document.querySelector('.js-yield_including_tax')
  const yieldPriceReturn = document.querySelectorAll('.yield_price_return')
  const yieldPriceReturnRecount = document.querySelectorAll('.yield_price_return_recount')
/** Доходность с учётом налога */
  const yield_including_tax__recount = () =>
  {
    let yiti = yieldIncludingTaxInput.value
    yieldPriceReturn.forEach((el, i) => {
      let ypr = el.innerText
      el.style.display = 'none'
      yieldPriceReturnRecount[i].style.display = 'block'
      yieldPriceReturnRecount[i].parentNode.style.boxShadow = '0 0 20px #e8c9db inset'

      let recount_ypr = ypr*(1-yiti/100)
      yieldPriceReturnRecount[i].innerText = bonds.formatNumber(recount_ypr, 2)
    })

  }

    if (yieldIncludingTax.classList.contains('is-active')) {
      yieldIncludingTaxInput.removeAttribute('disabled')
      yield_including_tax__recount()
    } else {
      yieldIncludingTaxInput.setAttribute('disabled', true)
      yieldIncludingTaxInput.value = '13'
    }

  yieldIncludingTaxInput.addEventListener('input', yield_including_tax__recount )

})

const buildFormData = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
    })
  } else {
    const value = data == null ? '' : data
    formData.append(parentKey, value)
  }
}

const jsonToFormData = (data) => {
  const formData = new FormData()
  buildFormData(formData, data)
  return formData
}

// Экспорт в excel
new $.fn.dataTable.Buttons( oTable, {
  buttons: [
    {
      text: '<span class="bonds__filters-download js-analytics-portfolio-replacement">' +
        '<span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg">' +
        '<use href="/assets/dist/img/sprite.svg#i-view-tabular"></use>' +
        '</svg></span><span>Подобрать аналоги для всех бумаг</span></span>' +
        '<div class="bonds__column-tooltip">' +
        '  <div class="bonds__column-tooltip_content bonds__column-tooltip_content--right">Формирует файл Excel с подбором лучших замен (альтернатив) для всех бумаг в таблице. Работает для первых 70 бумаг.</div>' +
        '   <span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg">' +
        '     <use href="/assets/dist/img/sprite.svg#i-answer"></use>' +
        '     </svg>' +
        '   </span>' +
        '</div>'
      ,
      action: function (e, dt, node, config) {
      }
    },
    {
      text: '<span class="bonds__filters-download"><span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg">' +
        '<use href="/assets/dist/img/sprite.svg#i-print"></use>' +
        '</svg></span><span class="bonds__filters-download--text js-micromodal-open" ' +
        'data-micromodal-id="modal-analytics-portfolio">Загрузка портфеля</span></span>' +
      '<div class="bonds__column-tooltip">' +
          '  <div class="bonds__column-tooltip_content bonds__column-tooltip_content--right">Загрузка портфеля (формат: Excel со списком ISIN в столбце A)</div>' +
        '   <span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg">' +
        '     <use href="/assets/dist/img/sprite.svg#i-answer"></use>' +
        '     </svg>' +
        '   </span>' +
        '</div>'
    },
    {
      extend: 'excelHtml5',
      text: '<a class="bonds__filters-download" href="favicon-32x32.png" download>' +
        '<span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg">' +
        '<use href="/assets/dist/img/sprite.svg#i-print"></use>' +
        '</svg></span><span class="bonds__filters-download--text">Скачать Excel</span></a>',
      extension: '.xlsx',
      charset: 'utf-8',
      bom: true,
      title: null,
      exportOptions: {
        columns: ':not(.no_export)',
        format: {
          header: function ( data, column ) {
            data = data.toString().replace(/<.*?>/g, "").trim()
            if ( column == 5 ) {
              data = 'Валюта номинала'
            }
            if ( column == 12 ) {
              data = 'Эффективная доходность (YTM), %'
            }
            if ( column == 17 ) {
              data = 'Кредитное качество (рэнкинг)'
            }
            if ( column == 19 ) {
              data = 'Качество эмитента (max=10)'
            }
            if ( column == 24 ) {
              data = 'Коэф. Ликвидности (max=100)'
            }
            return data
          },
          body: function ( data, row, column, node ) {
              data = data.toString().replace(/<.*?>/g, "")
              data = data.replace(/&quot;/g, '"')

            if(column == 11) { // Эффективная доходность (YTM), %
              data = data.split('yield')[1]
            }
            if (
              column == 16 || // Кредитное качество (рэнкинг)
              column == 18 || // Качество эмитента
              column == 22 // Коэф. Ликвидности
              ) {
              data = data.replace(/[\u0400-\u04FF]/g, '')
            }
            if (column == 1) {
              data = data.split('   ')[0]
            }
            return data
          }
        }
      },
      customize: function (xlsx) {
        let sheet = xlsx.xl.worksheets['sheet1.xml'];
        $('row c', sheet).attr( 's', '51' );
        $('row:eq(0) c', sheet).attr( 's', '7' );
      }
    },
  ]
} );

oTable.buttons().container()
  .appendTo( $('#DataTables_Table_0_length') );

const portfolioReplacement = document.querySelector('.js-analytics-portfolio-replacement')
portfolioReplacement.addEventListener('click', (e) => {
  MicroModal.show('modal-analytics-portfolio-replacement')
  let filename = ''
  let listForReplacement = ''
  let bestScore = ''
  if (oTable.ajax.url() == '/assets/components/dohodbonds/connectorweb.php?action=info') {
    listForReplacement = '&list=info'
  }
  const bestScoreInput = document.querySelectorAll('.js-best_score_input')[value__i]
  iBondCheckbox.forEach((ibch) => {
    if (ibch.classList.contains('is-active')) {
      const obj = oTable.rows().data()
      let bestScoreValuesArray = bonds.percentileSLiderUpdate(bestScoreInput.value, obj)
      bestScore = '&bestScore=' + bestScoreValuesArray[0]
    }
  })


  fetch('/assets/components/dohodbonds/connectorweb.php?action=groupreplacement' + listForReplacement + bestScore, {
    method: 'POST',
    body: jsonToFormData(postData),
  }).then((result) => {
    if (!result.ok) {
      throw Error(result.statusText)
    }
    // We are reading the *Content-Disposition* header for getting the original filename given from the server
    const header = result.headers.get('Content-Disposition')
    const parts = header.split(';')
    filename = parts[1].split('=')[1].replaceAll("\"", "")
    return result.blob()
  }).then((blob) => {
    if (blob != null) {
      MicroModal.close('modal-analytics-portfolio-replacement')
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
    }
  }).catch((err) =>
  {
    const agrc = document.querySelectorAll('.js-portfolio-replacement-container')[0]
    agrc.querySelector('div').style.display = 'none'
    agrc.innerHTML += '<h2>Упс! Мы не смогли обработать данные!</h2>'
    setTimeout(function () {
      MicroModal.close('modal-analytics-portfolio-replacement')
      agrc.querySelector('div').style.display = 'flex'
      agrc.querySelectorAll('h2').forEach((h) => {
        h.innerHTML = ''
      })

    }, 4000)
  })

})

const mobileSortingSelect = document.querySelector('.js-table-sorting')
mobileSortingSelect.addEventListener('change',() => {
  let val = mobileSortingSelect.options[mobileSortingSelect.selectedIndex].value
  switch (val) {
    case 'price_return_desc':
      oTable.order( [ 48, 'desc' ] ).draw()
      break;
    case 'price_return_asc':
      oTable.order( [ 48, 'asc' ] ).draw()
      break;
    case 'years_to_maturity_desc':
      oTable.order( [ 53, 'desc' ] ).draw()
      break;
    case 'years_to_maturity_asc':
      oTable.order( [ 53, 'asc' ] ).draw()
      break;
    case 'credit_rating_desc':
      oTable.order( [ 18, 'desc' ] ).draw()
      break;
    case 'credit_rating_asc':
      oTable.order( [ 18, 'asc' ] ).draw()
      break;
    case 'quality_desc':
      oTable.order( [ 50, 'desc' ] ).draw()
      break;
    case 'quality_asc':
      oTable.order( [ 50, 'asc' ] ).draw()
      break;
    case 'shortname_desc':
      oTable.order( [ 1, 'desc' ] ).draw()
      break;
    case 'shortname_asc':
      oTable.order( [ 1, 'asc' ] ).draw()
      break;
    case 'down_risk_desc':
      oTable.order( [ 51, 'desc' ] ).draw()
      break;
    case 'down_risk_asc':
      oTable.order( [ 51, 'asc' ] ).draw()
      break;
    case 'complexity_desc':
      oTable.order( [ 26, 'desc' ] ).draw()
      break;
    case 'complexity_asc':
      oTable.order( [ 26, 'asc' ] ).draw()
      break;
    case 'duration_desc':
      oTable.order( [ 52, 'desc' ] ).draw()
      break;
    case 'duration_asc':
      oTable.order( [ 52, 'asc' ] ).draw()
      break;
    case 'size_desc':
      oTable.order( [ 27, 'desc' ] ).draw()
      break;
    case 'size_asc':
      oTable.order( [ 27, 'asc' ] ).draw()
      break;
    case 'default':
      oTable.order( [ 24, 'desc' ] ).draw()
      break;
  }

})

/* поиск */
const searchInput = document.querySelector('.js__filter-input')
searchInput.addEventListener('keyup', (e) => {
    e.preventDefault()
      oTable.ajax.reload()
  });

const searchSubmit = document.querySelector('.js__filter-search-submit')
searchSubmit.addEventListener('click', (e) => {
  e.preventDefault()
  oTable.ajax.reload()
})

/*  Краткосрочная, Среднесрочная, Долгосрочная */
document.querySelectorAll('.js-years_to_maturity_checkbox').forEach((el) => {
  el.addEventListener('click', years_to_maturity_checkbox)
})
/* Надежные и качественные */
$('.js-checkbox__trust_proper').on('click', trust_proper_checkbox )
/* Простые и ликвидные */
$('.js-checkbox__simple_liquid').on('click', simple_liquid_checkbox )
/* Только ликвидные */
liquidity_checkbox.forEach((el) => {
  el.addEventListener('click', () => {
    if ( el.classList.contains('is-active') ) {
      liquidity_only__checkbox(true)
    } else {
      liquidity_only__checkbox(false)
    }
  } )
})

if (marketMapTabButton) {
  marketMapTabButton.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      if (el.classList.contains('bonds__filters-modal_btn')) {
        el.classList.toggle('is-active')
      }
      if (el.classList.contains('is-active')) {
        market_map_foo()
        document.querySelector('.js-market_map--section').classList.add('is-active')
        document.querySelector('.dataTables_wrapper').style.display = 'none'
        document.querySelector('.bonds__table-sorting--mobile').style.display = 'none'
        filterSetHandler(el, el.dataset.filter)
      } else {
        document.querySelector('.js-market_map--section').classList.remove('is-active')
        document.querySelector('.dataTables_wrapper').style.display = 'block'
        document.querySelector('.bonds__table-sorting--mobile').style.display = 'block'
        filterClearHandler(el.dataset.filter)
      }
    })
  })
}


// Новая модалка
// Инициализация компонента в модальном окне
async function dataBinding(isin, element) {
  // Установка значений
  element.bonddata= await getBondByIsin(isin)
  element.otherbonds= await getIsinsByIssuer(isin, 1)
  element.bondsfeatures= await getBondsFeatures(isin)
  element.selectionOfReplacementItems= await getSelectionOfReplacement(isin, 1)
  element.iBondsIsinsList= null
  element.marketmap= await getSelectionOfReplacement(isin, 3)
  // Подписка на события
  element.addEventListener('open-modal', openModal)
  element.addEventListener('change-option', changeOption)
  element.addEventListener('change-replacement-filter', changeReplacementFilter)
  element.addEventListener('update-replacement-range', updateReplacementRange)
  element.addEventListener('change-market-filter', changeMarketFilter)
  // Добавление пропущенных
  element.addEventListener('update-market-range', updatemarketRange)
  element.addEventListener('search-isin', searchIsin)
  return element
// Вызываем инициальные данные для заданного isin и передаем в компонент
}
// Закрытие модального окна
function closeModal () {
  let dohodModal = document.getElementsByTagName('dohod-modal')
  dohodModal[0].removeAttribute('opened')
}
// Установка данных для компонента после открытия модального окна
async function initModalComponents(payload) {
  // Получаем компонент и подписываемся на его изменения
  let bondElement= [...document.getElementsByTagName('bond-analysis')].find((el) => el.id === payload.detail)
  await dataBinding(payload.detail, bondElement)
}
// Открытие модального окна
async function openModal(payload) {
  let dohodModal = document.getElementsByTagName('dohod-modal')
  if(dohodModal.length > 0) {
    dohodModal[0].remove()
  }
  let element = document.createElement('dohod-modal')
  document.body.appendChild(element)
  // Установка id для поиска компонента по нему
  element.setAttribute('isin', payload.detail)
  // Открытие модального окна
  element.setAttribute('opened', true)
  // Подписка на события
  element.addEventListener('close-modal', closeModal)
  element.addEventListener('open-modal', initModalComponents)
}
// Получения полных данных по облигации
async function getBondByIsin(isin) {
  let res = await fetch(`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&isin=${ isin }`)
  return res.json()
}
// Получения полных данных для вкладки Другие облигации
async function getIsinsByIssuer(isin, option) {
  let res = await fetch(`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&isin=${ isin }&option=${ option }`)
  return res.json()
}
// Смена опции для вкладки Другие облигации
async function changeOption(event) {
  const option = event.detail[0]
  const element = event.srcElement
  const elementIsin = event.srcElement.bonddata.isin
  element.bondsdata = await getIsinsByIssuer(elementIsin, option)
}
// Получение замен для Подбора замен
async function getSelectionOfReplacement(isin, option) {
  try {
    const url =`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&replacement=1&option=${ option }`
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ isins: [isin] })
    })
    const json = await resp.json()
    return json[0].bonds
  } catch (e) {
    console.error(`Ошибка при получении данных для замены\n${ e }`)
    return []
  }
}
// Получение IBond isins для Подбора замен
async function getIBondsFromIsins(isinsArr, option) {
  try {
    const url = `/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&ibond=1&option=${ option }`
    const iBondsResponse = await fetch(url , {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ isins: isinsArr })
    })

    const json = await iBondsResponse .json()

    return json.isins
  } catch (e) {
    console.error(`Ошибка при получении данных для IBond\n${ e }`)
    return []
  }
}

async function updateReplacementRange(event) {
  const { selectedIBondsRange } = event.detail[0]
  const element = event.srcElement
  const replacementIsins = element.selectionOfReplacementItems.map(item => item.isin)
  element.iBondsIsinsList = await getIBondsFromIsins(replacementIsins, selectedIBondsRange.value)
}

async function changeReplacementFilter(event) {
  const { filter, selectedIBondsRange } = event.detail[0]
  const element = event.srcElement
  const elementIsin = event.srcElement.bonddata.isin
  if(filter.index === 3) {
    const replacementIsins = element.selectionOfReplacementItems.map(item => item.isin)
    element.iBondsIsinsList = !filter.checked ? await getIBondsFromIsins(replacementIsins, selectedIBondsRange.value) : null
  } else {
    element.selectionOfReplacementItems = await getSelectionOfReplacement(elementIsin, filter.value)
  }
}

async function getBondsFeatures(isin) {
  let res = await fetch(`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&features=1&isin=${ isin }`)
  return res.json()
}

async function changeMarketFilter(event) {
  const { filter, selectedIBondsRange } = event.detail[0]
  const element = event.srcElement
  const elementIsin = event.srcElement.bonddata.isin
  if (filter.index === 5) {
    const replacementIsins = element.marketmap.map(item => item.isin)
    element.marketmapIsinsList = !filter.checked ? await getIBondsFromIsins(replacementIsins, selectedIBondsRange.value) : null
  } else {
    element.marketmap = await getSelectionOfReplacement(elementIsin, filter.value)
  }
}

async function updatemarketRange(event) {
  const { selectedIBondsRange } = event.detail[0]
  const element = event.srcElement
  const replacementIsins = element.marketmap.map(item => item.isin)
  element.marketmapIsinsList = await getIBondsFromIsins(replacementIsins, selectedIBondsRange.value)
}
//Метод для добавления найденной в поиске облигации
async function searchIsin(event) {
  const filter = event.detail[0]
  const item = event.detail[1]
  const dateNow = event.detail[2]
  const element = event.srcElement
  element.searchdata = await getBondsByFilter(filter, item, dateNow)
}

async function getBondsByFilter(filters, item, dateNow) {
  try {
    const requestFilters = filters.join(`~~'${item}' or `)
    const dataLimitation = ` and bond.expiryDatePlan > '${dateNow}T00:00:00' and yearsToMaturity >: '0' and price >: '0'`
    const url = `/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&filter=(${requestFilters}~~'${item}')${dataLimitation}&page=0&size=20`
    const iBondsResponse = await fetch(url)
    const iBondsResponseContent = await iBondsResponse.json()
    return iBondsResponseContent['content']
  } catch (e) {
    console.error(`Ошибка при получении данных для IBond\n${e}`)
    return []
  }
}

bonds.commonFuncs()
